<template>
    <div class="">
        <div class="container">
            <Breadcrumb :breadcrumbs="breadcrumbs"></Breadcrumb>
            <section class="build_details_section build_v3_section" v-if="Object.keys(build_details).length > 0">
                <h1>Order Build: <span>{{ build_details.name }}</span> </h1>
                <div class="build_blocks">
                    <div class="row design_row">
                        <div class="col-md-6 main_block">
                            <!-- <h3>Design Name: <span>{{ build_details.name }}</span> </h3> -->
                        </div>
                        <div class="col-md-6 main_block" v-if="build_details.OrderBuildItems.length > 0">
                            <div class="row">
                                <div class="col-md-8">
                                    <div class="row">
                                        <div class="col-md-3 col-sm-3">
                                            <div
                                                :class="(build_details.front_image ? 'direction_block active' : 'direction_block')">
                                                <h5>{{(JSON.parse(build_details.OrderBuildItems[0].design_area_inches).length > 0 ) ? ((typeof JSON.parse(build_details.OrderBuildItems[0].design_area_inches)[0]['label_show'] !== "undefined" ) ? JSON.parse(build_details.OrderBuildItems[0].design_area_inches)[0].label_show : JSON.parse(build_details.OrderBuildItems[0].design_area_inches)[0].label): 'Front'}}</h5>
                                                <div class="img_box">
                                                    <a href="javascript:void(0);" v-if="build_details.front_image"
                                                        @click="showBuildImage((build_details.front_image ? build_details.front_image : '/maincss/design-images/default-img.svg'))">
                                                        <img :src="build_details.front_image"
                                                            alt="">
                                                    </a>
                                                    <img v-else :src="'/maincss/design-images/default-img.svg'"
                                                            alt="">
                                                </div>
                                                <ul v-if="build_details.front_color !== null && build_details.front_color !== 'null'">
                                                    <li v-for="( color1, index1 ) in JSON.parse(build_details.front_color)"
                                                        :style="'background-color:' + color1.hex + ';'" :key="index1"
                                                        v-show="hasLimit(build_details, index1)"
                                                        v-tooltip = "{
                                                            'content': color1.name ? `${color1.name}<br/>${color1.hex}` : color1.hex,
                                                            'html': true
                                                        }">
                                                    </li>
                                                    <div v-show="JSON.parse(build_details.front_color).length > colors_limit"
                                                        class="more_color_link">
                                                        <a href="#" class="dropdown-toggle"
                                                            :id="'dropdownMenuButtonLocationsart'" data-toggle="dropdown"
                                                            aria-haspopup="true" aria-expanded="false">
                                                            +{{ (JSON.parse(build_details.front_color).length - colors_limit) }}
                                                        </a>
                                                        <div class="dropdown-menu pt-0 cart_dropdown"
                                                            aria-labelledby="dropdownMenuButtonLocationsart">
                                                            <h4>
                                                                Colors
                                                                <span class=""> <img
                                                                        src="/maincss/images/cross.svg" /></span>
                                                            </h4>
                                                            <div class="dropdown-item d-flex align-items-center">
                                                                <!-- eslint-disable -->
                                                                <p class="mb-0">
                                                                <ul>
                                                                    <li v-for="( color1, index1 ) in JSON.parse(build_details.front_color)"
                                                                        :style="'background-color:' + color1.hex + ';'"
                                                                        v-tooltip = "{
                                                                            'content': color1.name ? `${color1.name}<br/>${color1.hex}` : color1.hex,
                                                                            'html': true
                                                                        }"
                                                                        :key="index1">
                                                                    </li>
                                                                </ul>
                                                                </p>
                                                                <!-- eslint-enable -->
                                                            </div>
                                                        </div>
                                                    </div>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="col-md-3 col-sm-3">
                                            <div
                                                :class="(build_details.back_image ? 'direction_block active' : 'direction_block')">
                                                <h5>{{(JSON.parse(build_details.OrderBuildItems[0].design_area_inches).length > 1 ) ?((typeof JSON.parse(build_details.OrderBuildItems[0].design_area_inches)[1]['label_show'] !== "undefined") ? JSON.parse(build_details.OrderBuildItems[0].design_area_inches)[1].label_show : JSON.parse(build_details.OrderBuildItems[0].design_area_inches)[1].label): 'Back'}}</h5>
                                                <div class="img_box">
                                                    <a href="javascript:void(0);" v-if="build_details.back_image"
                                                        @click="showBuildImage((build_details.back_image ? build_details.back_image : '/maincss/design-images/default-img.svg'))">
                                                        <img :src="build_details.back_image"
                                                            alt="">
                                                    </a>
                                                    <img v-else :src="'/maincss/design-images/default-img.svg'"
                                                            alt="">
                                                </div>
                                                <ul v-if="build_details.back_color !== null && build_details.back_color !== 'null'">
                                                    <li v-for="( color1, index1 ) in JSON.parse(build_details.back_color)"
                                                        :style="'background-color:' + color1.hex + ';'" :key="index1"
                                                        v-show="hasLimit(build_details, index1)" 
                                                        v-tooltip = "{
                                                            'content': color1.name ? `${color1.name}<br/>${color1.hex}` : color1.hex,
                                                            'html': true
                                                        }">
                                                    </li>
                                                    <div v-show="JSON.parse(build_details.back_color).length > colors_limit"
                                                        class="more_color_link">
                                                        <a href="#" class="dropdown-toggle"
                                                            :id="'dropdownMenuButtonLocationsart'" data-toggle="dropdown"
                                                            aria-haspopup="true" aria-expanded="false">
                                                            +{{ (JSON.parse(build_details.back_color).length - colors_limit) }}
                                                        </a>
                                                        <div class="dropdown-menu pt-0 cart_dropdown"
                                                            aria-labelledby="dropdownMenuButtonLocationsart">
                                                            <h4>
                                                                Colors
                                                                <span class=""> <img
                                                                        src="/maincss/images/cross.svg" /></span>
                                                            </h4>
                                                            <div class="dropdown-item d-flex align-items-center">
                                                                <p class="mb-0">
                                                                <ul>
                                                                    <li 
                                                                        v-for="( color1, index1 ) in JSON.parse(build_details.back_color)"
                                                                        :style="'background-color:' + color1.hex + ';'"
                                                                        :key="index1"
                                                                        v-tooltip = "{
                                                                            'content': color1.name ? `${color1.name}<br/>${color1.hex}` : color1.hex,
                                                                            'html': true
                                                                        }"
                                                                    >
                                                                    </li>
                                                                </ul>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="col-md-3 col-sm-3">
                                            <div
                                                :class="(build_details.left_image ? 'direction_block active' : 'direction_block')">
                                                <h5>{{(JSON.parse(build_details.OrderBuildItems[0].design_area_inches).length > 2 ) ?((typeof JSON.parse(build_details.OrderBuildItems[0].design_area_inches)[2]['label_show'] !== "undefined") ? JSON.parse(build_details.OrderBuildItems[0].design_area_inches)[2].label_show : JSON.parse(build_details.OrderBuildItems[0].design_area_inches)[2].label): 'Left'}}</h5>
                                                <div class="img_box">
                                                    <a href="javascript:void(0);" v-if="build_details.left_image"
                                                        @click="showBuildImage((build_details.left_image ? build_details.left_image : '/maincss/design-images/default-img.svg'))">
                                                        <img :src="build_details.left_image"
                                                            alt="">
                                                    </a>
                                                    <img v-else :src="'/maincss/design-images/default-img.svg'"
                                                            alt="">
                                                </div>
                                                <ul v-if="build_details.left_color !== null && build_details.left_color != 'null'">
                                                    <li v-for="( color1, index1 ) in JSON.parse(build_details.left_color)"
                                                        :style="'background-color:' + color1.hex + ';'" :key="index1"
                                                        v-show="hasLimit(build_details, index1)" 
                                                        v-tooltip = "{
                                                            'content': color1.name ? `${color1.name}<br/>${color1.hex}` : color1.hex,
                                                            'html': true
                                                        }" 
                                                    >
                                                    </li>
                                                    <div v-show="JSON.parse(build_details.left_color).length > colors_limit"
                                                        class="more_color_link">
                                                        <a href="#" class="dropdown-toggle"
                                                            :id="'dropdownMenuButtonLocationsart'" data-toggle="dropdown"
                                                            aria-haspopup="true" aria-expanded="false">
                                                            +{{ (JSON.parse(build_details.left_color).length - colors_limit) }}
                                                        </a>
                                                        <div class="dropdown-menu pt-0 cart_dropdown"
                                                            aria-labelledby="dropdownMenuButtonLocationsart">
                                                            <h4>
                                                                Colors
                                                                <span class=""> <img
                                                                        src="/maincss/images/cross.svg" /></span>
                                                            </h4>
                                                            <div class="dropdown-item d-flex align-items-center">
                                                                <p class="mb-0">
                                                                <ul>
                                                                    <li 
                                                                        v-for="( color1, index1 ) in JSON.parse(build_details.left_color)"
                                                                        :style="'background-color:' + color1.hex + ';'" 
                                                                        v-tooltip = "{
                                                                            'content': color1.name ? `${color1.name}<br/>${color1.hex}` : color1.hex,
                                                                            'html': true
                                                                        }"
                                                                        :key="index1">
                                                                    </li>
                                                                </ul>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="col-md-3 col-sm-3">
                                            <div
                                                :class="(build_details.right_image ? 'direction_block active' : 'direction_block')">
                                                <h5>{{(JSON.parse(build_details.OrderBuildItems[0].design_area_inches).length > 3 ) ?((typeof JSON.parse(build_details.OrderBuildItems[0].design_area_inches)[3]['label_show'] !== "undefined") ? JSON.parse(build_details.OrderBuildItems[0].design_area_inches)[3].label_show : JSON.parse(build_details.OrderBuildItems[0].design_area_inches)[3].label): 'Right'}}</h5>
                                                <div class="img_box">
                                                    <a href="javascript:void(0);" v-if="build_details.right_image"
                                                        @click="showBuildImage((build_details.right_image ? build_details.right_image : '/maincss/design-images/default-img.svg'))">
                                                        <img :src="build_details.right_image"
                                                            alt="">
                                                    </a>
                                                    <img v-else :src="'/maincss/design-images/default-img.svg'"
                                                            alt="">
                                                </div>
                                                <ul v-if="build_details.right_color !== null && build_details.right_color != 'null'">
                                                    <li v-for="( color1, index1 ) in JSON.parse(build_details.right_color)"
                                                        :style="'background-color:' + color1.hex + ';'" :key="index1"
                                                        v-show="hasLimit(build_details, index1)"
                                                        v-tooltip = "{
                                                            'content': color1.name ? `${color1.name}<br/>${color1.hex}` : color1.hex,
                                                            'html': true
                                                        }"
                                                    >
                                                    </li>
                                                    <div v-show="JSON.parse(build_details.right_color).length > colors_limit"
                                                        class="more_color_link">
                                                        <a href="#" class="dropdown-toggle"
                                                            :id="'dropdownMenuButtonLocationsart'" data-toggle="dropdown"
                                                            aria-haspopup="true" aria-expanded="false">
                                                            +{{ (JSON.parse(build_details.right_color).length - colors_limit) }}
                                                        </a>
                                                        <div class="dropdown-menu pt-0 cart_dropdown"
                                                            aria-labelledby="dropdownMenuButtonLocationsart">
                                                            <h4>
                                                                Colors
                                                                <span class=""> <img
                                                                        src="/maincss/images/cross.svg" /></span>
                                                            </h4>
                                                            <div class="dropdown-item d-flex align-items-center">
                                                                <p class="mb-0">
                                                                <ul>
                                                                    <li 
                                                                        v-for="( color1, index1 ) in JSON.parse(build_details.right_color)"
                                                                        :style="'background-color:' + color1.hex + ';'"
                                                                        :key="index1" 
                                                                        v-tooltip = "{
                                                                            'content': color1.name ? `${color1.name}<br/>${color1.hex}` : color1.hex,
                                                                            'html': true
                                                                        }" 
                                                                    >
                                                                    </li>
                                                                </ul>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <template v-if="build_details.OrderBuildItems.length > 0">
                        <div class="row design_row" v-for="(build_item, index) in build_details.OrderBuildItems" :key="index">
                            <div class="col-md-6 main_block">
                                <div class="row">
                                    <!-- <div class="left_block"> -->
                                    <div class="col-md-2 col-sm-2">
                                        <div class="product_img_col justify-content-center">
                                            <!-- <img :src="build_item.product_front_image"
                                                alt=""> -->
                                                <DisplayProductImage
                                                    v-if="build_item.MainNewProduct"
                                                    :whateverActivatesThisLink="true"
                                                    :tshirt24hour="build_item.t_shirt_24_hour"
                                                    :product="build_item.MainNewProduct"
                                                    :color="build_item.color_id"
                                                    :classValue="'m-auto1'"
                                                />

                                        </div>
                                        <div class="product_name mt_10" v-if="build_item.MainNewProduct">
                                            <h5>{{ build_item.MainNewProduct.product_number }}</h5>
                                            <a 
                                                v-if="build_item.name_and_number_json.length > 0"
                                                :id="'nameNumbers' + build_item.color_id"
                                                @click="openNameNumbersModal(build_item)"
                                                href="javascript:void(0);"
                                                class="d-flex align-items-center"
                                                aria-haspopup="true"
                                                aria-expanded="false"
                                            >
                                                <img src="/maincss/images/path.png" class="ml_6 path mb_10" />
                                            </a>
                                            
                                        </div>
                                    </div>

                                    <div class="col-md-8 sizes_table col-sm-8">
                                        <div class="tabs_table d-md-flex size_color_table">

                                            <div class="sizez_columns">
                                                <span v-if="build_item.t_shirt_24_hour">24hour T-shirt</span>
                                                <div class="d-flex flex-wrap inner_size_table">
                                                    <div class="product_count"  v-for="(size, size_index) in build_item.color_data.sizes" :key="size_index">
                                                        <div class="count_item_heading">
                                                            <h6 class="m-0">{{ size.Size.size }}</h6>
                                                            <span>
                                                                {{
                                                                    icPriceFormat(
                                                                        getRetailPrice({
                                                                            base_price: parseFloat(size.case_price),
                                                                            markup_price: parseFloat(size.markup_price),
                                                                            single_location_price: parseFloat(size.single_location_price || 0),
                                                                            color_category_price: getDarkLightFees(build_item.Color, build_item.MainNewProduct),
                                                                            decoration_discount_percentage: size.decoration_discount_percentage
                                                                        })
                                                                    )
                                                                }}
                                                            </span>
                                                        </div>
                                                        <div class="count_item_price">
                                                            <input 
                                                                type="text" placeholder="0"
                                                                class="form-control" 
                                                                v-model="size.quantity"
                                                                oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');"
                                                                @change="calculatePricing(build_item, size, $event)"
                                                            >
                                                        </div>
                                                    </div>
                                                    <div class="product_count total_count">
                                                        <div class="count_item_heading">
                                                            <h6 class="m-0">Total</h6>
                                                        </div>
                                                        <div class="count_item_price total_box">
                                                            <span><b>{{ icPriceFormat(build_item.color_data.total_price) }}</b></span>
                                                            <div class="dropdown" v-if="build_item.color_data.total_quantity > 0">
                                                                <a href="javascript:void(0);"
                                                                    class="dropdown-toggle d-flex align-items-center"
                                                                    :id="'dropdownMenuButton' + build_item.color_id"
                                                                    data-toggle="dropdown" aria-haspopup="true"
                                                                    aria-expanded="false">
                                                                    <img src="/maincss/images/path.png" class="ml_6 path" />
                                                                </a>

                                                                <div class="dropdown-menu drop-cart-menu drop_product"
                                                                    aria-labelledby="dropdownMenuButton">
                                                                    <h4 class="font_size_16 text_primary_blue py_2 px_20">
                                                                        {{ toTitleCase(build_item.Color.name) }}
                                                                        <span class="cross_ic">
                                                                            <img src="/maincss/images/cross.svg" />
                                                                        </span>
                                                                    </h4>
                                                                    <div class="scroll">
                                                                        <div>
                                                                            <div class="col-md-12">
                                                                                <div class="mt_10 d-flex flex-wrap justify-content-left color_checkbox ">
                                                                                    <div class="table-responsive">
                                                                                        <table width="100%"
                                                                                            class="table-bordered comma-decimal-place table-data table-hover space_b">
                                                                                            <thead>
                                                                                                <tr>
                                                                                                    <th>Size</th>
                                                                                                    <th>Quantity</th>
                                                                                                    <th>Total</th>
                                                                                                </tr>
                                                                                            </thead>
                                                                                            <tbody>
                                                                                                <tr v-for="(size, ind) in build_item.color_data.sizes"
                                                                                                    :key="ind"
                                                                                                    v-show="size.quantity > 0">
                                                                                                    <td class="size">{{
                                                                                                        size.Size.size }}</td>
                                                                                                    <td> {{ size.quantity }} *
                                                                                                        {{
                                                                                                            icPriceFormat(size.unit_price)
                                                                                                        }} </td>
                                                                                                    <td>
                                                                                                        {{
                                                                                                            icPriceFormat(size.total_price)
                                                                                                        }}
                                                                                                    </td>
                                                                                                </tr>
                                                                                            </tbody>
                                                                                        </table>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="term_notes">
                                            <p v-if="build_item.notes">
                                                <span>Note: </span> {{ showNotes(build_item.notes, build_item.show_more_notes) }}
                                                <a href="javascript:void(0);"
                                                    v-if="!build_item.show_more_notes && (build_item.notes.length > notes_limit)"
                                                    @click="showMoreNotes(build_item, true)" style="font-size: 15px"> Show
                                                    More</a>
                                                <a href="javascript:void(0);"
                                                    v-else-if="(build_item.notes.length > notes_limit)" style="font-size: 15px"
                                                    @click="showMoreNotes(build_item, false)"> ... Less </a>
                                            </p>
                                            <div class="create_note">
                                                <a href="javascript:void(0);" data-toggle="modal" data-target="#creatNotes"
                                                    @click="getNote(build_item.id, (build_item.notes) ? build_item.notes : '')">{{
                                                        (build_item.notes) ? 'Update' : 'Create'
                                                    }} Note</a>
                                            </div>
                                        </div>
                                        <!-- </div> -->
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 main_block">
                                <div class="row">
                                    <div class="col-md-8">
                                        <div class="row">
                                            <div class="col-md-3 col-sm-3">
                                                <div
                                                    :class="(build_item.front_image ? 'direction_block active' : 'direction_block')">
                                                    <div class="img_box">
                                                        <a href="javascript:void(0);" v-if="build_item.front_image"
                                                            @click="showBuildImage((build_item.front_image) ? build_item.front_image : build_details.front_image)">
                                                            <img :src="build_item.front_image"
                                                                alt="">
                                                        </a>
                                                        <img v-else :src="'/maincss/design-images/default-img.svg'"
                                                                alt="">
                                                    </div>
                                                    <ul
                                                        v-if="build_item.front_color !== null && build_item.front_color != 'null'">
                                                        <li v-for="( color1, index1 ) in removeTshirtColor(build_item.front_color,build_item.Color.hex)"
                                                            :style="'background-color:' + color1.hex + ';'" :key="index1"
                                                            v-show="hasLimit(build_item, index1)"
                                                            v-tooltip = "{
                                                                'content': color1.name ? `${color1.name}<br/>${color1.hex}` : color1.hex,
                                                                'html': true
                                                            }"    
                                                        >
                                                        </li>
                                                        <div v-show="removeTshirtColor(build_item.front_color,build_item.Color.hex).length > colors_limit"
                                                            class="more_color_link">
                                                            <!-- <a href="javascript:void(0);javascript:void(0);" v-if="build_details.is_color_show_more">-</a> 
                                                            <a href="javascript:void(0);javascript:void(0);" v-else>+{{ build_item.front_color.length - colors_limit }}</a>  -->
                                                            <a href="#" class="dropdown-toggle"
                                                                :id="'dropdownMenuButtonLocationsart'" data-toggle="dropdown"
                                                                aria-haspopup="true" aria-expanded="false">
                                                                +{{ (removeTshirtColor(build_item.front_color,build_item.Color.hex).length - colors_limit) }} </a>
                                                            <div class="dropdown-menu pt-0 cart_dropdown"
                                                                aria-labelledby="dropdownMenuButtonLocationsart">
                                                                <h4>
                                                                    Colors
                                                                    <span class=""> <img
                                                                            src="/maincss/images/cross.svg" /></span>
                                                                </h4>
                                                                <div class="dropdown-item d-flex align-items-center">
                                                                    <p class="mb-0">
                                                                    <ul>
                                                                        <li 
                                                                            v-for="( color1, index1 ) in removeTshirtColor(build_item.front_color,build_item.Color.hex)"
                                                                            :style="'background-color:' + color1.hex + ';'"
                                                                            :key="index1"
                                                                            v-tooltip = "{
                                                                                'content': color1.name ? `${color1.name}<br/>${color1.hex}` : color1.hex,
                                                                                'html': true
                                                                            }"
                                                                        >
                                                                        </li>
                                                                    </ul>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div class="col-md-3 col-sm-3">
                                                <div
                                                    :class="(build_item.back_image ? 'direction_block active' : 'direction_block')">
                                                    <div class="img_box">
                                                        <a href="javascript:void(0);" v-if="build_item.back_image"
                                                            @click="showBuildImage((build_item.back_image) ? build_item.back_image : build_details.back_image)">
                                                            <img :src="build_item.back_image"
                                                                alt="">
                                                        </a>
                                                        <img v-else :src="'/maincss/design-images/default-img.svg'"
                                                                alt="">
                                                    </div>
                                                    <ul
                                                        v-if="build_item.back_color !== null && build_item.back_color != 'null'">
                                                        <li v-for="( color1, index1 ) in removeTshirtColor(build_item.back_color,build_item.Color.hex)"
                                                            :style="'background-color:' + color1.hex + ';'" :key="index1"
                                                            v-show="hasLimit(build_item, index1)"
                                                            v-tooltip = "{
                                                                'content': color1.name ? `${color1.name}<br/>${color1.hex}` : color1.hex,
                                                                'html': true
                                                            }"
                                                        >
                                                        </li>
                                                        <div v-show="removeTshirtColor(build_item.back_color,build_item.Color.hex).length > colors_limit"
                                                            class="more_color_link">
                                                            <a href="#" class="dropdown-toggle"
                                                                :id="'dropdownMenuButtonLocationsart'" data-toggle="dropdown"
                                                                aria-haspopup="true" aria-expanded="false">
                                                                +{{ (removeTshirtColor(build_item.back_color,build_item.Color.hex).length - colors_limit) }}
                                                            </a>
                                                            <div class="dropdown-menu pt-0 cart_dropdown"
                                                                aria-labelledby="dropdownMenuButtonLocationsart">
                                                                <h4>
                                                                    Colors
                                                                    <span class=""> <img
                                                                            src="/maincss/images/cross.svg" /></span>
                                                                </h4>
                                                                <div class="dropdown-item d-flex align-items-center">
                                                                    <p class="mb-0">
                                                                    <ul>
                                                                        <li v-for="( color1, index1 ) in removeTshirtColor(build_item.back_color,build_item.Color.hex)"
                                                                            :style="'background-color:' + color1.hex + ';'"
                                                                            :key="index1"
                                                                            v-tooltip = "{
                                                                                'content': color1.name ? `${color1.name}<br/>${color1.hex}` : color1.hex,
                                                                                'html': true
                                                                            }"
                                                                        >
                                                                        </li>
                                                                    </ul>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div class="col-md-3 col-sm-3">
                                                <div
                                                    :class="(build_item.left_image ? 'direction_block active' : 'direction_block')">
                                                    <div class="img_box">
                                                        <a href="javascript:void(0);" v-if="build_item.left_image"
                                                            @click="showBuildImage(build_item.left_image,build_item.Color.hex)">
                                                            <img :src="build_item.left_image" :style="'background-color:' + build_item.Color.hex + ';'"
                                                                alt="">
                                                        </a>
                                                        <img v-else :src="'/maincss/design-images/default-img.svg'"
                                                                alt="">
                                                    </div>
                                                    <ul
                                                        v-if="build_item.left_color !== null && build_item.left_color != 'null'">
                                                        <li v-for="( color1, index1 ) in removeTshirtColor(build_item.left_color,build_item.Color.hex)"
                                                            :style="'background-color:' + color1.hex + ';'" :key="index1"
                                                            v-show="hasLimit(build_item, index1)"
                                                            v-tooltip = "{
                                                                'content': color1.name ? `${color1.name}<br/>${color1.hex}` : color1.hex,
                                                                'html': true
                                                            }"
                                                        >
                                                        </li>
                                                        <div v-show="removeTshirtColor(build_item.left_color,build_item.Color.hex).length > colors_limit"
                                                            class="more_color_link">
                                                            <a href="#" class="dropdown-toggle"
                                                                :id="'dropdownMenuButtonLocationsart'" data-toggle="dropdown"
                                                                aria-haspopup="true" aria-expanded="false">
                                                                +{{ (removeTshirtColor(build_item.left_color,build_item.Color.hex).length - colors_limit) }}
                                                            </a>
                                                            <div class="dropdown-menu pt-0 cart_dropdown"
                                                                aria-labelledby="dropdownMenuButtonLocationsart">
                                                                <h4>
                                                                    Colors
                                                                    <span class=""> <img
                                                                            src="/maincss/images/cross.svg" /></span>
                                                                </h4>
                                                                <div class="dropdown-item d-flex align-items-center">
                                                                    <p class="mb-0">
                                                                    <ul>
                                                                        <li v-for="( color1, index1 ) in removeTshirtColor(build_item.left_color,build_item.Color.hex)"
                                                                            :style="'background-color:' + color1.hex + ';'"
                                                                            :key="index1" 
                                                                            v-tooltip = "{
                                                                                'content': color1.name ? `${color1.name}<br/>${color1.hex}` : color1.hex,
                                                                                'html': true
                                                                            }"
                                                                        >
                                                                        </li>
                                                                    </ul>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div class="col-md-3 col-sm-3">
                                                <div
                                                    :class="(build_item.right_image ? 'direction_block active' : 'direction_block')">
                                                    <!-- <h5>Right</h5> -->
                                                    <div class="img_box">
                                                        <a href="javascript:void(0);" v-if="build_item.right_image"
                                                            @click="showBuildImage(build_item.right_image,build_item.Color.hex)">
                                                            <img :src="build_item.right_image" :style="'background-color:' + build_item.Color.hex + ';'"
                                                                alt="">
                                                        </a>
                                                        <img v-else :src="'/maincss/design-images/default-img.svg'"
                                                                alt="">
                                                    </div>

                                                    <ul
                                                        v-if="build_item.right_color !== null && build_item.right_color != 'null'">
                                                        <li v-for="( color1, index1 ) in removeTshirtColor(build_item.right_color,build_item.Color.hex)"
                                                            :style="'background-color:' + color1.hex + ';'" :key="index1"
                                                            v-show="hasLimit(build_item, index1)"
                                                            v-tooltip = "{
                                                                'content': color1.name ? `${color1.name}<br/>${color1.hex}` : color1.hex,
                                                                'html': true
                                                            }"
                                                        >
                                                        </li>
                                                        <div v-show="removeTshirtColor(build_item.right_color,build_item.Color.hex).length > colors_limit"
                                                            class="more_color_link">
                                                            <a href="#" class="dropdown-toggle"
                                                                :id="'dropdownMenuButtonLocationsart'" data-toggle="dropdown"
                                                                aria-haspopup="true" aria-expanded="false">
                                                                +{{ (removeTshirtColor(build_item.right_color,build_item.Color.hex).length - colors_limit) }}
                                                            </a>
                                                            <div class="dropdown-menu pt-0 cart_dropdown"
                                                                aria-labelledby="dropdownMenuButtonLocationsart">
                                                                <h4>
                                                                    Colors
                                                                    <span class=""> <img
                                                                            src="/maincss/images/cross.svg" /></span>
                                                                </h4>
                                                                <div class="dropdown-item d-flex align-items-center">
                                                                    <p class="mb-0">
                                                                    <ul>
                                                                        <li v-for="( color1, index1 ) in removeTshirtColor(build_item.right_color,build_item.Color.hex)"
                                                                            :style="'background-color:' + color1.hex + ';'"
                                                                            :key="index1"
                                                                            v-tooltip = "{
                                                                                'content': color1.name ? `${color1.name}<br/>${color1.hex}` : color1.hex,
                                                                                'html': true
                                                                            }"
                                                                        >
                                                                        </li>
                                                                    </ul>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4 edit_del_col">
                                        <div class="row">
                                            <div class="col-md-4 col-md-4" v-if="build_item.color_data.imprint_locations">
                                                <div class="dropdown">
                                                    <a 
                                                        href="javascript:void(0);"
                                                        class="dropdown-toggle d-flex align-items-center"
                                                        :id="'decorationColors'"
                                                        data-toggle="dropdown" 
                                                        aria-haspopup="true"
                                                        aria-expanded="false"
                                                    >
                                                        <img src="/maincss/images/path.png" class="ml_6 path" />
                                                    </a>
                                                    <div class="dropdown-menu location_colors drop-cart-menu  drop_product"  aria-labelledby="dropdownMenuButton">
                                                        <h4 class="font_size_16 text_primary_blue py_2 px_20">
                                                            <span> Cost </span>
                                                            <span class="cross_ic"><img src="/maincss/images/cross.svg"></span>
                                                        </h4>
                                                        <div class="scroll">

                                                            <div class="dropdown-item d-flex align-items-center"
                                                                v-if="parseFloat(build_item.color_data.subtotal) > 0">
                                                                <p class="font-weight-bold w-90 m-0">Base:</p>
                                                                <p class="ml-auto mb-0">{{ icPriceFormat(build_item.color_data.subtotal) }}</p>
                                                            </div>

                                                            <div class="dropdown-item d-flex align-items-center"
                                                                v-if="parseFloat(build_item.color_data.total_design_fee) > 0">
                                                                <p class="font-weight-bold w-90 m-0">Design Fee:</p>
                                                                <p class="ml-auto mb-0">{{ icPriceFormat(build_item.color_data.total_design_fee) }}</p>
                                                            </div>

                                                            <div class="dropdown-item d-flex align-items-center"
                                                                v-if="parseFloat(build_item.color_data.front_number_fees) > 0">
                                                                <p class="font-weight-bold w-90 m-0">Front Number Fee:</p>
                                                                <p class="ml-auto mb-0">{{ icPriceFormat(build_item.color_data.front_number_fees) }}</p>
                                                            </div>
                                                        
                                                            <div class="dropdown-item d-flex align-items-center"
                                                                v-if="parseFloat(build_item.color_data.back_name_fees) > 0">
                                                                <p class="font-weight-bold w-90 m-0">Back Name Fee:</p>
                                                                <p class="ml-auto mb-0">{{ icPriceFormat(build_item.color_data.back_name_fees) }}</p>
                                                            </div>    
                                                            
                                                            <div class="dropdown-item d-flex align-items-center"
                                                                v-if="parseFloat(build_item.color_data.back_number_fees) > 0">
                                                                <p class="font-weight-bold w-90 m-0">Back Number Fee:</p>
                                                                <p class="ml-auto mb-0">{{ icPriceFormat(build_item.color_data.back_number_fees) }}</p>
                                                            </div> 

                                                            <div class="dropdown-item d-flex align-items-center"
                                                                v-if="parseFloat(build_item.color_data.front_number_decor_up_fees) > 0">
                                                                <p class="font-weight-bold w-90 m-0">Front Number Decor Up Fee:</p>
                                                                <p class="ml-auto mb-0">{{ icPriceFormat(build_item.color_data.front_number_decor_up_fees) }}</p>
                                                            </div>

                                                            <div class="dropdown-item d-flex align-items-center"
                                                                v-if="parseFloat(build_item.color_data.back_name_decor_up_fees) > 0">
                                                                <p class="font-weight-bold w-90 m-0">Back Name Decor Up Fee:</p>
                                                                <p class="ml-auto mb-0">{{ icPriceFormat(build_item.color_data.back_name_decor_up_fees) }}</p>
                                                            </div>

                                                            <div class="dropdown-item d-flex align-items-center"
                                                                v-if="parseFloat(build_item.color_data.back_number_decor_up_fees) > 0">
                                                                <p class="font-weight-bold w-90 m-0">Back Number Decor Up Fee:</p>
                                                                <p class="ml-auto mb-0">{{ icPriceFormat(build_item.color_data.back_number_decor_up_fees) }}</p>
                                                            </div>


                                                            <div v-for="(location, key) in build_item.color_data.imprint_locations"
                                                                :key="key">
                                                                <div v-if="location.no_of_color"
                                                                    class="dropdown-item d-flex align-items-center">
                                                                    <p v-if="build_item.decoration_type == 1" class="font-weight-bold"> Imprint Location: {{  location.location }} </p>
                                                                    <p v-else-if="build_item.decoration_type == 2" class="font-weight-bold"> Embroidery Location: {{  location.location }} </p>
                                                                    <p class="ml-auto" v-if="location.total_decoration_fee">
                                                                        {{ icPriceFormat(location.total_decoration_fee) }}
                                                                    </p>
                                                                </div>

                                                                <div 
                                                                    v-for="(colors, color_key) in location.colors.filter(color => color.color)"
                                                                    :key="color_key"
                                                                    class="dropdown-item d-flex align-items-center"
                                                                >
                                                                    <p v-if="colors.color"
                                                                        class="font-weight-bold w-25">
                                                                        Color {{ color_key + 1 }} -
                                                                        {{ colors.color.color_name }}:
                                                                    </p>
                                                                    <p class="ml-auto" v-if="(colors.color.color_id == 0) && colors.color.non_standard_fee">
                                                                        {{ icPriceFormat(colors.color.non_standard_fee) }}
                                                                    </p>
                                                                    <p class="ml-auto" v-else-if="colors.total_decor_upcharge">
                                                                        {{ icPriceFormat(colors.total_decor_upcharge) }}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-4 col-sm-4">
                                                <a href="javascript:void(0);"
                                                    @click="editBuildItem(build_item, index_value_arr[index])" class="mr-20">
                                                    <img src="/maincss/images/pen.svg" alt="">
                                                </a>
                                            </div>
                                            <div class="col-md-4 col-sm-4">
                                                <a href="javascript:void(0);" @click="deleteBuildItem(build_item.id)">
                                                    <img src="/maincss/images/delete-blue.svg" alt="">
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </template>
                    <div class="row design_row b-none">
                        <div class="col-md-6 main_block">
                            <div class="row">
                                <div class="col-md-3 col-sm-3">
                                    <p class="title">Total Items</p>
                                    <p class="desc">{{ build_details.OrderBuildItems.length }}
                                    </p>
                                </div>
                                <div class="col-md-3 col-sm-3 cart_artwork_popup_custom show" v-if="build_details.total_standard_decoration_colors.length > 0">
                                    <p class="title">Standard Colors</p>
                                    
                                    <ul class="colors" v-show="build_details.total_standard_decoration_colors != 'null'">
                                        <li v-for="( color1, index1 ) in build_details.total_standard_decoration_colors"
                                            :style="'background-color:' + color1.hex + ';'" :key="index1"
                                            v-show="hasTotalColorsLimit(build_details, index1)"
                                            v-tooltip = "{
                                                'content': color1.name ? `${color1.name}<br/>${color1.hex}` : color1.hex,
                                                'html': true
                                            }"
                                        >
                                        </li>
                                        <li v-show="build_details.total_standard_decoration_colors.length > colors_limit"
                                            class="more_color_link"
                                            @click="() => {
                                                build_details.is_total_color_show_more = !build_details.is_total_color_show_more;
                                                $forceUpdate();
                                            }">
                                            <a href="javascript:void(0);" v-if="build_details.is_total_color_show_more">-</a>
                                            <a href="javascript:void(0);" v-else>+{{
                                                build_details.total_standard_decoration_colors.length - colors_limit }}</a>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-4 col-sm-4" v-if="build_details.total_non_standard_colors.length > 0">
                                    <p class="title" v-if="decoration_type == 1">Custom Ink Mix Colors (${{ non_standard_fees_per_color }} each)</p>
                                    <p class="title" v-else-if="decoration_type == 2">Custom Thread Colors (${{ non_standard_fees_per_color }} each)</p>
                                    <ul class="colors" v-show="build_details.total_non_standard_colors != 'null'">
                                        <li 
                                            v-for="( color1, index1 ) in build_details.total_non_standard_colors"
                                            :style="'background-color:' + color1 + ';'" :key="index1"
                                            v-show="hasTotalNonStandardColorsLimit(build_details, index1)"
                                            v-tooltip = "color1"
                                        >
                                        </li>
                                        <li v-show="build_details.total_non_standard_colors.length > colors_limit"
                                            class="more_color_link"
                                            @click="() => {
                                                build_details.is_total_non_standard_color_show_more = !build_details.is_total_non_standard_color_show_more;
                                                $forceUpdate();
                                            }">
                                            <a href="javascript:void(0);" v-if="build_details.is_total_non_standard_color_show_more">-</a>
                                            <a href="javascript:void(0);" v-else>+{{
                                                build_details.total_non_standard_colors.length - colors_limit }}</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                        </div>
                        <div class="offset-md-3 col-md-3">
                            <div class="row">
                                <div class="col-md-12 col-sm-12 d-flex justify-content-between" v-if="build_details.setup_fee > 0">
                                    <p class="title" v-if="decoration_type == 1">Per Color Setup Up Fee ( {{ build_details.total_decoration_colors_count }} * {{ icPriceFormat(build_details.per_color_setup_cost) }} ): </p>
                                    <p class="title" v-else-if="decoration_type == 2">Digitizing Fee: </p>
                                    <p class="desc ml-1">{{ icPriceFormat(build_details.setup_fee) }}</p>
                                </div>
                                <div class="col-md-12 col-sm-12 d-flex justify-content-between" v-if="build_details.total_non_standard_fees > 0">
                                    <p class="title" v-if="decoration_type == 1">Custom Ink Mix Fee ( {{ build_details.total_non_standard_colors.length }} * {{ icPriceFormat(non_standard_fees_per_color) }} ): </p>
                                    <p class="title" v-else-if="decoration_type == 2">Custom Thread Mix Fee ( {{ build_details.total_non_standard_colors.length }} * {{ icPriceFormat(non_standard_fees_per_color) }} ): </p>
                                    <p class="desc ml-1">{{ icPriceFormat(build_details.total_non_standard_fees) }}</p>
                                </div>
                                <div class="col-md-12 col-sm-12 d-flex justify-content-between">
                                    <p class="title">Total: </p>
                                    <p class="desc ml-1">{{ icPriceFormat(build_details.total_price) }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bottom_buttons row">
                        <div class="col-md-6 p-0 main_block">
                            <div class="left_block">
                                <a type="button" @click="$refs.addAnotherItemComp.openModal()"
                                    class="btn btn_outline_primary dark_blue_button">
                                    ADD ANOTHER ITEM
                                </a>
                            </div>
                        </div>
                        <div class="col-md-6 p-0 main_block" v-if="build_details.OrderBuildItems.length > 0">
                            <div class="right_block">
                                <a href="javascript:void(0);" @click="saveForLater"
                                    class="btn btn_outline_primary border_primary_blue text_primary_blue py_18 px_46 mr_20">
                                    SAVE FOR LATER
                                </a>
                                <a href="javascript:void(0);" @click="addToCart"
                                    class="btn btn_orange btn btn_orange bg_primary_orange text_white py_18 px_64 ml_20">
                                    ADD TO CART
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <SearchProducts 
                    ref="addAnotherItemComp" 
                    :build-details="build_details"
                    :vendor-colors-list="vendor_colors_list"
                    :non-standard-color-obj="nonStandardColorObj"
                    :decoration-colors="decoration_colors"
                    :getMarkupFromTier="getMarkupFromTier"
                ></SearchProducts>
            </section>
        </div>
        <div class="modal fade notes_modal build_product_modal" id="creatNotes" tabindex="-1" role="dialog"
            aria-labelledby="exampleModalLongTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLongTitle">Note</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <img src="/maincss/images/cancel.svg" alt="">
                        </button>
                    </div>
                    <form method="post" @submit.prevent="addNote" data-vv-scope="addshapeform">
                        <div class="modal-body">
                            <div class="form-group mt-0">
                                <!-- <label>Write a note</label> -->
                                <textarea
                                rows="5"
                                placeholder="Write a note"
                                v-model="item_note"
                                class="form-control"
                                id="notesTextarea">
                                </textarea>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button data-dismiss="modal"
                                class="btn btn_outline_primary border_primary_blue text_primary_blue py_18 px_46 mr_20 ">
                                CANCEL
                            </button>
                            <button type="submit"
                                class="btn btn_orange btn btn_orange bg_primary_orange text_white py_18 ml_20">
                                Save
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="modal fade build_product_modal" id="buildProduct" tabindex="-1" role="dialog"
            aria-labelledby="exampleModalLongTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <img src="/maincss/images/cancel.svg" alt="">
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="product_img">
                            <img :src="(current_image) ? current_image : '/maincss/design-images/default-img.svg'"
                            :style="'background-color:' + current_image_color + ';'" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- NAME & NUMBERS MODAL -->
        <div class="modal fade name_number_popup" id="nameNumbersModal" aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="modal-title fs-5" id="exampleModalToggleLabel">Name & Numbers</h3>
                        <div class="close_modal">
                            <a href="#" class="popup-close art_poup_close" id="popup-close"
                                data-dismiss="modal" ref="popupclose">
                                <span aria-hidden="true" v-tooltip="'Close'">&times;</span>
                            </a>
                        </div>
                        <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
                    </div>
                    <div class="modal-body">
                        <div class="d-flex flex-row">
                            <div class="text-center" v-if="name_and_number_json.front.length > 0">
                                <h5>Front Location</h5>
                                <div class="scroll">
                                    <div>
                                        <div class="col-md-12">
                                            <div class="d-flex flex-wrap justify-content-left color_checkbox ">
                                                <div class="table-responsive">
                                                    <table class="name-number-data mt-0">
                                                        <thead class="data-head">
                                                            <tr class="cart-data-col">
                                                                <th class="data-heading">
                                                                    Number
                                                                </th>
                                                                <th class="data-heading">Size</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody class="data-body">
                                                            <tr v-for="(namesAndNumber, key) in name_and_number_json.front" :key="key" class="cart-data-col">
                                                                <td>
                                                                    {{ namesAndNumber.number }}
                                                                </td>
                                                                <td>{{ namesAndNumber.size }}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="text-center" v-if="name_and_number_json.back.length > 0">
                                <h5>Back Location</h5>
                                <div class="scroll">
                                    <div>
                                        <div class="col-md-12">
                                            <div class="d-flex flex-wrap justify-content-left color_checkbox ">
                                                <div class="table-responsive">
                                                    <table v-if="name_and_number_json.back.length > 0" class="name-number-data mt-0">
                                                        <thead class="data-head">
                                                            <tr class="cart-data-col">
                                                                <th v-if="selected_name_number.back.name" class="data-heading">
                                                                    Name
                                                                </th>
                                                                <th v-if="selected_name_number.back.number" class="data-heading">
                                                                    Number
                                                                </th>
                                                                <th class="data-heading">Size</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody class="data-body">
                                                            <tr v-for="(namesAndNumber, key) in name_and_number_json.back" :key="key" class="cart-data-col">
                                                                <td v-if="selected_name_number.back.name">
                                                                    {{ namesAndNumber.name || '-' }}
                                                                </td>
                                                                <td v-if="selected_name_number.back.number">
                                                                    {{ namesAndNumber.number || '-' }}
                                                                </td>
                                                                <td>{{ namesAndNumber.size }}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <!-- LOADER -->
        <div class="preloader" v-show="isLoader">
            <div class="preloader-body">
                <svg width="40" height="40" viewBox="0 0 40 40">
                    <polygon class="rect" points="0 0 0 40 40 40 40 0"></polygon>
                </svg>
            </div>
        </div>
    </div>
</template>
<script>
import ApiService from "@/common/api.service";
import SearchProducts from "../V3/AddAnotherItems.vue";
import Breadcrumb from "@/components/Breadcrumb";
import DisplayProductImage from "@/components/DisplayProductImageNew";
import { mapGetters } from "vuex";

export default {
    name: "BuildDetails",
    components: {
        SearchProducts: SearchProducts,
        Breadcrumb: Breadcrumb,
        DisplayProductImage: DisplayProductImage
    },
    data() {
        return {
            isLoader: false,
            build_details: '',
            selected_design_images: [],
            breadcrumbs: [],
            colors_limit: 4,
            notes_limit: 125,
            current_image: '',
            current_image_color: '',
            current_selected_id: '',
            item_note: '',
            index_value_arr: [],
            max_cart_count: 2000,
            tshirt_size_orders: [
                "XS", "S", "M", "L", "XL", "XXL", "2XL", "3XL", "4XL", "5XL", "6XL", "7XL",
                "8XL", "9XL", "10XL", "11XL", "12XL", "13XL", "14XL", "OSFM", "YXS", "YS",
                "YM", "YL", "YXL", "1T", "2T", "3T", "4T", "5T", "6T"
            ],
            build_screens: 0,
            decoration_type: null,
            decoration_price_template: null,
            markup_tiers: [],
            vendor_data: null,
            vendor_colors_list: [],
            decoration_colors: [],
            nonStandardColorObj: null,
            non_standard_fees_per_color: 0,
            name_and_number_json: { front: [], back: [] },
            selected_name_number: { 
                front: { name: false, number: false },
                back: { name: false, number: false },
            }
        }
    },
    mounted() {
        this.breadcrumbs = [
            { name: `Design Studio`, url: '/design-studio/v3' },
            { name: `Build Listing`, url: '/design-studio/v3/build-list' },
            { name: `Build Item Listing` }
        ];

        this.getBuildData();
    },
    computed: {
        ...mapGetters(["decorationPrices", "decorationTemplate", "adminOptions", "getSingleLocation", "printTemplates", "embroideryTemplates"])
    },
    methods: {
        removeTshirtColor(colorJson,tshirtColor){
            let productColors = JSON.parse(colorJson);
            let index = productColors.indexOf(tshirtColor);
            if(index != -1)
                productColors.splice(index,1);
            return productColors;
        },
        
        editBuildItem(buildItem) {
            let current_product = null;
            return new Promise((resolve, reject) => {
                if (!buildItem.MainNewProduct) {
                    console.error('MainNewProduct is null for buildItem:', buildItem);
                    this.isLoader = false;
                    reject(new Error('Product information not available'));
                    return;
                }
                
                this.isLoader = true;
                ApiService.get("/home-single-newproduct-new/" + buildItem.product_id).then(async ({ data }) => {
                    current_product = data.product;

                    current_product.available_colors = [];
                    current_product.decoration_type = buildItem.decoration_type;
                    current_product.decoration_price_template = buildItem.decoration_price_template;
                    current_product.more_decorations = buildItem.more_decorations;
                    current_product.price_decoration_bulk = buildItem.price_decoration_bulk;
                    current_product.price_color_category_dark = buildItem.MainNewProduct ? buildItem.MainNewProduct.price_color_category_dark : 0;
                    current_product.price_color_category_light = buildItem.MainNewProduct ? buildItem.MainNewProduct.price_color_category_light : 0;

                    let availableColors = this.groupArrayOfObjects(current_product.MainNewSubProducts, 'color_id');
                    Object.values(availableColors).forEach(color => {
                        if (color[0].Color.id == buildItem.color_id) {
                            current_product.available_colors.push({
                                id: color[0].Color.id,
                                color_name: color[0].Color.name,
                                hash: color[0].Color.hex,
                                pms: color[0].Color.pms,
                                swatches: color[0].Color.swatches,
                                shades: color[0].Color.shades,
                                category: color[0].Color.category,
                                default_selection: color[0].default_selection,
                                is_selected: false
                            })
                        }
                    })


                    this.loadVendorColors(current_product)


                    current_product.NewProductImages = buildItem.MainNewProduct ? (buildItem.MainNewProduct.NewProductImages || []) : [];

                    let new_canvas_elements = {};
                    let canvas_design_colors = {};

                    if (buildItem.front_design) {
                        new_canvas_elements['front'] = buildItem.front_design;
                    }

                    if (buildItem.back_design) {
                        new_canvas_elements['back'] = buildItem.back_design;
                    }

                    if (buildItem.left_design) {
                        new_canvas_elements['left'] = buildItem.left_design;
                    }

                    if (buildItem.right_design) {
                        new_canvas_elements['right'] = buildItem.right_design;
                    }

                    if (buildItem.distress_images) {
                        new_canvas_elements['distress_images'] = JSON.parse(buildItem.distress_images)
                    }

                    if (buildItem.front_color) {
                        canvas_design_colors['front'] = JSON.parse(buildItem.front_color).map(col => col.hex);
                    }

                    if (buildItem.back_color) {
                        canvas_design_colors['back'] = JSON.parse(buildItem.back_color).map(col => col.hex);
                    }

                    if (buildItem.left_color) {
                        canvas_design_colors['left'] = JSON.parse(buildItem.left_color).map(col => col.hex);
                    }

                    if (buildItem.right_color) {
                        canvas_design_colors['right'] = JSON.parse(buildItem.right_color).map(col => col.hex);
                    }


                    let items = [];
                    let sizes = JSON.parse(JSON.stringify(buildItem.color_data.sizes));
                    sizes.forEach(size => {
                        size.price_base = size.case_price;
                        size.cost = size.unit_price;
                        size.total_cost = size.total_price;

                        delete size.unit_price;
                        delete size.unit_price;
                        delete size.total_price;
                    }) 

                    let color = {
                        id: buildItem.color_id,
                        color_name: buildItem.Color.name,
                        hash: buildItem.Color.hex,
                        pms: buildItem.Color.pms,
                        swatches: buildItem.Color.swatches,
                        shades: buildItem.Color.shades,
                        category: buildItem.Color.category,
                        default_selection: 1,
                        is_selected: true,
                        front_number_fees: buildItem.color_data.front_number_fees,
                        back_name_fees: buildItem.color_data.back_name_fees,
                        back_number_fees: buildItem.color_data.back_number_fees,
                        front_number_decor_up_fees: buildItem.color_data.front_number_decor_up_fees,
                        back_name_decor_up_fees: buildItem.color_data.back_name_decor_up_fees,
                        back_number_decor_up_fees: buildItem.color_data.back_number_decor_up_fees,
                        name_and_number_json: buildItem.name_and_number_json || null,
                        selected_name_number: buildItem.color_data.selected_name_number,
                        total_cost_gender_wise: buildItem.color_data.total_price,
                        total_qty_gender_wise: buildItem.color_data.total_quantity,
                        total_color_fee: 0,
                        total_dark_category_fee: buildItem.color_data.total_dark_category_fee,
                        total_light_category_fee: buildItem.color_data.total_light_category_fee,
                        total_discount_value: buildItem.color_data.total_discount_value || 0.00,
                        total_design_fee: buildItem.color_data.total_design_fee || 0.00,
                        unique_sizes: sizes,
                        imprint_locations: buildItem.color_data.imprint_locations
                    }
                    let subtotal_price = this.getTotalColorPrice( buildItem.color_data);
                    let total_price = parseFloat(subtotal_price)
                        + parseFloat(buildItem.color_data.name_fees || 0)
                        + parseFloat(buildItem.color_data.number_fees || 0)
                        + parseFloat(buildItem.color_data.name_decor_up_fees || 0)
                        + parseFloat(buildItem.color_data.number_decor_up_fees || 0)
                        + parseFloat(this.build_details.total_non_standard_fees);
                    items.push({
                        item: current_product,
                        colors: [color],
                        gender_name: buildItem.Genderagesize.gender,
                        gender_id: buildItem.gender_size_id,
                        base_price: current_product.price_base,
                        total_qty: buildItem.color_data.total_quantity,
                        subtotal: parseFloat(subtotal_price),
                        total_cost:  total_price,
                        total_design_fee:0,
                        total_discount_value:0,
                        total_setup_fee: this.build_details.setup_fee,
                        total_name_fees: buildItem.color_data.name_fees,
                        total_number_fees: buildItem.color_data.number_fees,
                        total_name_decor_up_fees: buildItem.color_data.name_decor_up_fees,
                        total_number_decor_up_fees: buildItem.color_data.number_decor_up_fees,
                        total_non_standard_fees: 0,
                        total_color_fee: 0,
                        first_build_item_id: this.build_details.OrderBuildItems[0]['id'],
                        imprint_locations:  buildItem.color_data.imprint_locations,
                    })

                    new_canvas_elements['products_id'] = buildItem.product_id;
                    new_canvas_elements['build_item_id'] = buildItem.id;
                    new_canvas_elements['first_build_item_id'] = this.build_details.OrderBuildItems[0]['id'];
                    new_canvas_elements['build_id'] = this.build_details.id;
                    let build_canvas_design_colors = {};

                    this.build_details.OrderBuildItems.forEach(item => {
                        build_canvas_design_colors[item.id] = {
                            front: item.front_decoration_colors || [],
                            back: item.back_decoration_colors || [],
                            left: item.left_decoration_colors || [],
                            right: item.right_decoration_colors || [],
                        }
                    })

                    localStorage.setItem('new_canvas_elements', JSON.stringify(new_canvas_elements));
                    localStorage.setItem('build_canvas_design_colors', JSON.stringify(build_canvas_design_colors));
                    localStorage.setItem('total_build_items', this.build_details.OrderBuildItems.length);
                    localStorage.setItem('canvas_design_colors', JSON.stringify(canvas_design_colors));
                    localStorage.setItem("design_build", JSON.stringify(items));
                    localStorage.setItem("is24Tshirt", false);
                    localStorage.setItem("colorIndex", 0);
                    this.$router.push({ name: 'DesignStudioBuildV3' });

                    this.isLoader = false;
                    resolve(data);
                }).catch((err) => {
                    this.isLoader = false;
                    console.log(err);
                    reject(err);
                })
            })
        },

        prepareBuildDecorationColors(buildItems) {
            let decoration_colors =  {
                front: [],
                back: [],
                left: [],
                right: []
            }
            for (const [ buildItem ] of Object.entries(buildItems)) {
                // Preparing the front area colors
                if (buildItem.front_color) {
                    buildItem.front_decoration_colors = buildItem.front_color ? JSON.parse(buildItem.front_color).map(color => color.hex) : [];
                }

                // Preparing the back area colors
                if (buildItem.back_color) {
                    buildItem.back_decoration_colors = buildItem.back_color ? JSON.parse(buildItem.back_color).map(color => color.hex) : [];
                }

                // Preparing the left area colors
                if (buildItem.left_color) {
                    buildItem.left_decoration_colors = buildItem.left_color ? JSON.parse(buildItem.left_color).map(color => color.hex) : [];
                }

                // Preparing the right area colors
                if (buildItem.right_color) {
                    buildItem.right_decoration_colors = buildItem.right_color ? JSON.parse(buildItem.right_color).map(color => color.hex) : [];
                }
            }

            return decoration_colors;
        },

        showBuildImage(image, image_color = '') {
            if (image == '/maincss/design-images/default-img.svg' || image === null || image == 'null') {
                return true;
            } else {
                this.current_image = image;
                this.current_image_color = image_color;
                /* eslint-disable */
                $("#buildProduct").modal("show");
                /* eslint-enable */
            }
        },

        hasLimit(build, index) {
            if (!build.is_color_show_more) {
                return index < this.colors_limit;
            }
            return true;
        },

        hasTotalColorsLimit(build, index) {
            if (!build.is_total_color_show_more) {
                return index < this.colors_limit;
            }
            return true;
        },

        hasTotalNonStandardColorsLimit(build, index) {
            if (!build.is_total_non_standard_color_show_more) {
                return index < this.colors_limit;
            }
            return true;
        },

        getBuildData() {
            this.isLoader = true;
            ApiService.get("get-build-detail/" + this.$route.params.id).then(async ({ data }) => {

                    await this.getAllMarkupTiers();

                    
                    this.selected_design_images = [];
                    let orderBuild = data.orderBuild;

                    orderBuild.is_color_show_more = false;
                    orderBuild.total_price = 0.00;
                    orderBuild.setup_fee = 0.00;
                    orderBuild.total_front_number_fees = 0.00;
                    orderBuild.total_back_name_fees = 0.00;
                    orderBuild.total_back_number_fees = 0.00;
                    orderBuild.total_front_number_decor_up_fees = 0.00;
                    orderBuild.total_back_name_decor_up_fees = 0.00;
                    orderBuild.total_back_number_decor_up_fees = 0.00;

                    orderBuild.total_non_standard_fees = 0.00;
                    orderBuild.total_non_standard_colors = [];
                    orderBuild.imprint_locations = [];
                    orderBuild.total_colors_fee = 0;
                    let total_standard_decoration_colors =[];
                    let total_colors = [];
                    let total_screens = 0;

                    if (orderBuild.OrderBuildItems.length > 0) {
                        this.decoration_type = orderBuild.OrderBuildItems[0].decoration_type;
                        this.decoration_price_template = orderBuild.OrderBuildItems[0].decoration_price_template;
                        let colors_type = '';
                        if (this.decoration_type == 1) {
                            colors_type = 'ink';
                        } else if (this.decoration_type == 2) {
                            colors_type = 'thread';
                        }
                        if (orderBuild.OrderBuildItems[0].MainNewProduct && orderBuild.OrderBuildItems[0].MainNewProduct.default_decorator_id) {
                            await this.getVendorData(orderBuild.OrderBuildItems[0].MainNewProduct.default_decorator_id, colors_type);
                        }
                    }
                    

                    let non_standard_fees_sp_obj = this.adminOptions.find(option => option.option_key == 'non_standard_color_fees');
                    let non_standard_fees_emb_obj = this.adminOptions.find(option => option.option_key == 'non_standard_color_fees_emb');

                    let non_standard_fees = 0;

                    if (this.decoration_type == 1) {
                        if (non_standard_fees_sp_obj && non_standard_fees_sp_obj.option_value) {
                            non_standard_fees = parseFloat(non_standard_fees_sp_obj.option_value) || 0;
                        }
                        let printTemplate = this.printTemplates.find(temp => temp.id == this.decoration_price_template);
                        orderBuild.per_color_setup_cost = printTemplate.per_color_setup_cost;
                    } else if (this.decoration_type == 2) {
                        if (non_standard_fees_emb_obj && non_standard_fees_emb_obj.option_value) {
                            non_standard_fees = parseFloat(non_standard_fees_emb_obj.option_value) || 0;
                        }
                    }

                    this.non_standard_fees_per_color = non_standard_fees;


                    this.nonStandardColorObj = {
                        "color_id": 0,
                        "color_name": "Mix Color",
                        "color_pms": "Non Standard",
                        "non_standard_fee": non_standard_fees,
                        "decor_upcharge": 0,
                        "color_value": "#GGGGGG",
                        "swatches": "",
                        "category": "Non Standard",
                        "shades": []
                    };
                    
                    this.decoration_colors = {
                        front: [],
                        back: [],
                        left: [],
                        right: []
                    }


                    for (let [key, buildItem] of Object.entries(orderBuild.OrderBuildItems)) {
                        // Skip if MainNewProduct is not available
                        if (!buildItem.MainNewProduct) {
                            console.error('MainNewProduct is null for buildItem:', buildItem);
                            continue;
                        }

                        orderBuild.OrderBuildItems[key].is_color_show_more = false;

                        buildItem.name_and_number_json = buildItem.name_and_number_json
                            ? JSON.parse(buildItem.name_and_number_json)
                            : [];

                        // Preparing the front area colors
                        if (buildItem.front_color) {
                            buildItem.front_decoration_colors = buildItem.front_color ? JSON.parse(buildItem.front_color).map(color => color.hex) : [];
                            this.decoration_colors['front'] = [ ...new Set([ ...this.decoration_colors['front'], ...buildItem.front_decoration_colors ])];
                        }

                        // Preparing the back area colors
                        if (buildItem.back_color) {
                            buildItem.back_decoration_colors = buildItem.back_color ? JSON.parse(buildItem.back_color).map(color => color.hex) : [];
                            this.decoration_colors['back'] = [ ...new Set([ ...this.decoration_colors['back'], ...buildItem.back_decoration_colors ])];
                        }

                        // Preparing the left area colors
                        if (buildItem.left_color) {
                            buildItem.left_decoration_colors = buildItem.left_color ? JSON.parse(buildItem.left_color).map(color => color.hex) : [];
                            this.decoration_colors['left'] = [ ...new Set([ ...this.decoration_colors['left'], ...buildItem.left_decoration_colors ])];
                        }

                        // Preparing the right area colors
                        if (buildItem.right_color) {
                            buildItem.right_decoration_colors = buildItem.right_color ? JSON.parse(buildItem.right_color).map(color => color.hex) : [];
                            this.decoration_colors['right'] = [ ...new Set([ ...this.decoration_colors['right'], ...buildItem.right_decoration_colors ])];
                        }

                        if (buildItem.decoration_colors) {
                            total_colors = total_colors.concat(JSON.parse(buildItem.decoration_colors));
                        }

                        if (buildItem.standard_colors) {
                            total_standard_decoration_colors = total_standard_decoration_colors.concat(JSON.parse(buildItem.standard_colors));
                        }
                        
                        buildItem.color_data = buildItem.color_data ? JSON.parse(buildItem.color_data) : [];

                        if (buildItem.decoration_type == 2) {
                            buildItem.MainNewProduct.price_color_category_dark = 0;
                            buildItem.MainNewProduct.price_color_category_light = 0;
                        }

                        buildItem.MainNewProduct.price_decoration_bulk = buildItem.MainNewProduct.price_decoration_bulk ? JSON.parse(buildItem.MainNewProduct.price_decoration_bulk): []
                        buildItem.MainNewProduct.more_decoration = buildItem.MainNewProduct.more_decoration ? JSON.parse(buildItem.MainNewProduct.more_decoration): []
                        buildItem.price_decoration_bulk = buildItem.price_decoration_bulk ? JSON.parse(buildItem.price_decoration_bulk) : []
                        buildItem.more_decorations = buildItem.more_decorations ? JSON.parse(buildItem.more_decorations) : []

                        if (
                            (buildItem.decoration_type == buildItem.MainNewProduct.decoration_type) &&
                            (buildItem.decoration_price_template == buildItem.MainNewProduct.decoration_price_template)
                        ) {
                            // buildItem.MainNewProduct.price_decoration_bulk = buildItem.MainNewProduct.price_decoration_bulk;
                            // buildItem.MainNewProduct.more_decoration = buildItem.MainNewProduct.more_decoration;
                            console.log('');
                        } else {
                            buildItem.MainNewProduct.price_decoration_bulk = buildItem.price_decoration_bulk;
    
                            buildItem.MainNewProduct.more_decoration = buildItem.more_decorations;
                        }

                        buildItem.MainNewProduct.decoration_type = buildItem.decoration_type;
                        buildItem.MainNewProduct.decoration_price_template = buildItem.decoration_price_template;

                        let product_front_image = buildItem.MainNewProduct.NewProductImages && buildItem.MainNewProduct.NewProductImages.find ? buildItem.MainNewProduct.NewProductImages.find(image => 
                            (image.color_id == buildItem.color_id) &&
                            (image.type == 'front')
                        ) : null;
                        if (product_front_image) {
                            buildItem.product_front_image = product_front_image.url
                        }
                        let product_back_image = buildItem.MainNewProduct.NewProductImages && buildItem.MainNewProduct.NewProductImages.find ? buildItem.MainNewProduct.NewProductImages.find(image => 
                            (image.color_id == buildItem.color_id) &&
                            (image.type == 'back')
                        ) : null;
                        if (product_back_image) {
                            buildItem.product_back_image = product_back_image.url
                        }
                    }

                    // Making unique total decoration colors 
                    let total_colors_copied = JSON.parse(JSON.stringify(total_colors));
                    orderBuild.total_colors = [];
                    total_colors_copied.forEach(color => {
                        let colorExists = orderBuild.total_colors.find(col => col.hex === color.hex);
                        if (!colorExists) {
                            orderBuild.total_colors.push(color)
                        }
                    });

                    // Making unique total standard decoration colors
                    let total_standard_colors_copied = JSON.parse(JSON.stringify(total_standard_decoration_colors));
                    orderBuild.total_standard_decoration_colors = [];
                    total_standard_colors_copied.forEach(color => {
                        let colorExists = orderBuild.total_standard_decoration_colors.find(col => col.hex === color.hex);
                        if (!colorExists) {
                            orderBuild.total_standard_decoration_colors.push(color)
                        }
                    });

                    for (let [buildItemIndex, buildItem] of Object.entries(orderBuild.OrderBuildItems)) {
                        // Skip if MainNewProduct is not available
                        if (!buildItem.MainNewProduct) {
                            console.error('MainNewProduct is null for buildItem:', buildItem);
                            continue;
                        }

                        if (buildItem.MainNewProduct.decoration_price_type == 'global_price') {
                            await this.updateWithGlobalPrices(buildItem, orderBuild);
                        }

                        

                        buildItem.non_standard_fees_per_item = non_standard_fees;


                        let front_number = false;
                        if (buildItem.front_design) {
                            let front_design = buildItem.front_design ? JSON.parse(buildItem.front_design): {};
                            if (front_design && front_design.objects) {
                                let front_number_exist = front_design.objects.find(obj => obj.objType === 'number');
                                if (front_number_exist) {
                                    /* eslint-disable */
                                    front_number = true;
                                    /* eslint-enable */
                                }
                            }
                        }
                        
                        
                        let non_standard_colors = buildItem.non_standard_colors
                            ? JSON.parse(buildItem.non_standard_colors)
                            : [];

                        if (non_standard_colors) {
                            buildItem.color_data.total_price+=parseFloat(buildItem.color_data.non_standard_fees);
                            orderBuild.total_non_standard_colors = orderBuild.total_non_standard_colors.concat(non_standard_colors);
                        }

                        // buildItem.color_data.imprint_locations_price = this.calculateDecorationColorsPricing(buildItem.color_data.total_quantity, buildItem.color_data, buildItem);
                        // Preparing build level prices.
                        if (buildItemIndex == 0) {
                            
                            orderBuild.total_decoration_colors_count = 0;
                            for (const [colors] of Object.entries(this.decoration_colors)) {
                                orderBuild.total_decoration_colors_count+=colors.length;
                            }

                            if (buildItem.decoration_type == 1) {
                                let template = this.printTemplates.find(temp => temp.id == buildItem.decoration_price_template);
                                if (template) {
                                    buildItem.color_data.setup_fee = parseFloat(template.per_color_setup_cost) * orderBuild.total_decoration_colors_count;
                                }
                            } else if (buildItem.decoration_type == 2) {
                                let template = this.embroideryTemplates.find(temp => temp.id == buildItem.decoration_price_template);
                                if (template) {
                                    buildItem.color_data.setup_fee = parseFloat(template.machine_fee);
                                }
                            }
                            orderBuild.setup_fee = parseFloat(buildItem.color_data.setup_fee || 0);
                            orderBuild.total_price += parseFloat(buildItem.color_data.setup_fee || 0);

                        }

                        this.prepareDecorationPrices(buildItem.MainNewProduct);

                        this.calculateAllCharges(buildItem, orderBuild);
                        
                        orderBuild.total_front_number_fees+= parseFloat(buildItem.color_data.front_number_fees || 0);
                        orderBuild.total_back_name_fees+= parseFloat(buildItem.color_data.back_name_fees || 0);
                        orderBuild.total_back_number_fees+= parseFloat(buildItem.color_data.back_number_fees || 0);
                        orderBuild.total_front_number_decor_up_fees+= parseFloat(buildItem.color_data.front_number_decor_up_fees || 0);
                        orderBuild.total_back_name_decor_up_fees+= parseFloat(buildItem.color_data.back_name_decor_up_fees || 0);
                        orderBuild.total_back_number_decor_up_fees+= parseFloat(buildItem.color_data.back_number_decor_up_fees || 0);

                        orderBuild.total_colors_fee+= parseFloat(buildItem.color_data.imprint_locations_price || 0);
                        orderBuild.total_price+=parseFloat(buildItem.color_data.total_price);
                    }

                    orderBuild.total_non_standard_colors = [...new Set(orderBuild.total_non_standard_colors)];

                    orderBuild.total_non_standard_fees = orderBuild.total_non_standard_colors.length * non_standard_fees;
                    orderBuild.total_price+= orderBuild.total_non_standard_fees;

                    if (orderBuild.front_color != null && orderBuild.front_color != 'null') {
                            total_screens++;    
                        }
                    if (orderBuild.back_color != null && orderBuild.back_color != 'null') {
                        total_screens++; 
                    }
                    if (orderBuild.left_color != null && orderBuild.left_color != 'null') {
                        total_screens++; 
                    }
                    if (orderBuild.right_color != null && orderBuild.right_color != 'null') {
                        total_screens++; 
                    }

                    this.build_details = orderBuild;
                    this.build_screens = total_screens*orderBuild.OrderBuildItems.length;
                    this.isLoader = false;
                })
                .catch((response) => {
                    this.isLoader = false;
                    console.log(response);
                });
        },

        async updateWithGlobalPrices(buildItem, orderBuild) {
            if (!buildItem.MainNewProduct) {
                console.error('MainNewProduct is null for buildItem:', buildItem);
                return;
            }

            if (buildItem.MainNewProduct.decoration_type === 1) {
                const printTemplate = this.getDecorationTemplateData(buildItem.MainNewProduct.decoration_type, buildItem.MainNewProduct.decoration_price_template);
                buildItem.MainNewProduct.price_decoration_bulk = {
                    print_location1: printTemplate.PrintLocation1Templates,
                    print_location2: printTemplate.PrintLocation2Templates,
                }
                buildItem.MainNewProduct.price_color_category_dark = printTemplate.price_dark;
                buildItem.MainNewProduct.price_color_category_light = printTemplate.price_light;
            } else if (buildItem.MainNewProduct.decoration_type === 2) {
                const embroideryTemplate = this.getDecorationTemplateData(buildItem.MainNewProduct.decoration_type, buildItem.MainNewProduct.decoration_price_template);
                // buildItem.MainNewProduct.price_decoration_bulk = {
                //     print_location1: embroideryTemplate.EmbroideryQuantities
                // }
                buildItem.MainNewProduct.price_decoration_bulk = embroideryTemplate.EmbroideryQuantities
                buildItem.MainNewProduct.price_color_category_dark = embroideryTemplate.price_dark;
                buildItem.MainNewProduct.price_color_category_light = embroideryTemplate.price_light;
            }

            this.calculateAllCharges(buildItem, orderBuild)
        },
        
        deleteBuildItem(build_item_id) {
            if (confirm("Do you really want to delete?")) {
                new Promise(() => {
                    ApiService.delete("/delete-build-item/" + build_item_id)
                        .then(() => {
                            this.$toast.success("Order Build Item deleted successfully", {
                                position: "top-right"
                            });
                            this.getBuildData();
                        })
                        .catch(() => { });
                });
            }
        },

        getNote(build_item_id, notes) {
            this.current_selected_id = build_item_id;
            this.item_note = notes;
        },

        addNote() {
            let _this = this;
            _this.isLoader = true;
            let sendData = {
                id: _this.current_selected_id,
                note: _this.item_note
            };
            _this.$validator.validateAll("addshapeform").then((isValid) => {
                if (isValid) {
                    _this.isLoader = false;
                    new Promise(() => {
                        ApiService.put("/save-build-item-note", sendData)
                            .then(({ data }) => {
                                _this.isLoader = false;
                                if (!data.success) {
                                    _this.$toast.error(data.error, {
                                        position: "top-right"
                                    })
                                    return;
                                }
                                _this.$toast.success(data.message, {
                                    position: "top-right"
                                });
                                _this.build_details.OrderBuildItems.filter(
                                    (val) => {
                                        if (val.id == _this.current_selected_id) {
                                            val.notes = _this.item_note
                                        }

                                    }
                                );
                                _this.current_selected_id = '';
                                /* eslint-disable */
                                $("#creatNotes").modal("hide");
                                /* eslint-enable */
                            })
                            .catch(({ response }) => {
                                console.log(response.status.errors);
                            });
                    });
                } else {
                    console.log(_this.errors, 'showing error');
                }
            });
        },

        showNotes(notes, show_more) {
            if (!show_more && (notes.length > this.notes_limit)) {
                return `${notes.slice(0, this.notes_limit)}...`;
            }

            return notes
        },

        showMoreNotes(item, show_more) {
            item.show_more_notes = show_more;
            this.$forceUpdate();
        },

        loadVendorColors(product) {
            
            let imprint_colors_array_for_template = [];
            if (product.Decorators && product.Decorators.length) {
                let vendorColors = [];
                if (product.default_decorator_id) {
                    let default_decorator = product.Decorators.find(decorator => decorator.id == product.default_decorator_id);
                    vendorColors = default_decorator.VendorColors;
                } else {
                    vendorColors = product.Decorators[0].VendorColors;
                }
                // Added Colors
                if (vendorColors.length > 0) {
                    for (const color of vendorColors) {
                        if (!color.Color) {
                            continue;
                        }
                        let colorsData = {
                            color_id: color.color_id,
                            color_name: color.Color.name,
                            color_pms: color.Color.pms,
                            decor_upcharge: color.decor_upcharge,
                            color_value: color.Color.hex,
                            swatches: color.Color.swatches,
                            category: color.Color.category,
                            shades: color.Color.shades ? JSON.parse(color.Color.shades) : []
                        };

                        if (color.Color.type == 'ink' && product.decoration_type == 1) {
                            imprint_colors_array_for_template.push(colorsData);
                        } else if (color.Color.type == 'thread' && product.decoration_type == 2) {
                            imprint_colors_array_for_template.push(colorsData);
                        } else if (color.Color.type == 'vinyl' && (product.decoration_type != 1 && product.decoration_type != 2)) {
                            imprint_colors_array_for_template.push(colorsData);
                        }
                    }
                    // Added new color Data in Product objects
                    if (product.Vendor) {
                        product.Vendor.newVendorColors = imprint_colors_array_for_template;
                    }
                } else if (product.Vendor) {
                    let vendor_colors = product.Vendor.vendor_colors
                        ? JSON.parse(product.Vendor.vendor_colors)
                        : [];

                    if (product.decoration_type == 1) {
                        imprint_colors_array_for_template = vendor_colors.color_data_for_ink;
                    } else if (product.decoration_type == 2) {
                        imprint_colors_array_for_template = vendor_colors.color_data_for_thread;
                    } else {
                        imprint_colors_array_for_template = vendor_colors.color_data_for_vinyl;
                    }
                }
            }
        },

        getTotalColorQuantity(color) {
            let quantity = 0;

            color.sizes.forEach(size => {
                if (size.quantity) {
                    quantity += parseInt(size.quantity);
                }
            })

            return quantity;
        },

        getTotalColorPrice(color) {
            let total_price = 0;

            color.sizes.forEach(size => {
                if (size.total_price) {
                    total_price += parseFloat(size.total_price);
                }
            })

            return total_price;
        },

        calculateAllCharges(buildItem, orderBuild) {
            if (!buildItem.MainNewProduct) {
                console.error('MainNewProduct is null for buildItem:', buildItem);
                return;
            }
            
            buildItem.color_data.total_price = 0;
            let total_build_quantity = 0;
            orderBuild.OrderBuildItems.forEach(item => {
                item.color_data.total_quantity = 0;
                item.color_data.sizes.forEach(size => {
                    total_build_quantity+=parseInt(size.quantity || 0);
                    item.color_data.total_quantity+=parseInt(size.quantity || 0);
                })
            })

            let color_category_price = 0;
            if (buildItem.Color && buildItem.Color.category == "Dark") {
                color_category_price = buildItem.MainNewProduct.price_color_category_dark || 0;
                buildItem.color_data.total_dark_category_fee = parseInt(buildItem.color_data.total_quantity) * parseFloat(color_category_price);
            } else if (buildItem.Color && buildItem.Color.category == "Light") {
                color_category_price = buildItem.MainNewProduct.price_color_category_light || 0;
                buildItem.color_data.total_light_category_fee = parseInt(buildItem.color_data.total_quantity) * parseFloat(color_category_price);
            }

            let single_location_price = this.getDecorationPrice(buildItem.MainNewProduct, total_build_quantity);
            buildItem.color_data.sizes.forEach((item) => {
                item.ink_price = parseFloat(color_category_price);
                item.single_location_price = parseFloat(single_location_price);
                item.decoration_discount_percentage = this.getDecorationDiscount(buildItem.MainNewProduct, total_build_quantity);
                if (buildItem.MainNewProduct.decoration_price_type == 'global_price') {
                    item.markup_percentage = this.getMarkupFromTier(item.case_price, buildItem.MainNewProduct.decoration_type, buildItem.MainNewProduct.decoration_price_template);
                } else {
                    item.markup_percentage = parseFloat(buildItem.MainNewProduct.price_markup_percentage || 0);
                }
                item.markup_price = parseFloat(item.case_price) * (parseFloat(item.markup_percentage) / 100);
                item.unit_price = this.getRetailPrice({
                    base_price: parseFloat(item.case_price),
                    markup_price: parseFloat(item.markup_price),
                    single_location_price: parseFloat(single_location_price),
                    color_category_price: parseFloat(color_category_price),
                    decoration_discount_percentage: parseFloat(item.decoration_discount_percentage)
                })
                item.total_price = this.icPriceFormat(item.unit_price, true) * parseInt(item.quantity || 0);
                buildItem.color_data.total_price+=parseFloat(item.total_price);
            });

            buildItem.color_data.subtotal = buildItem.color_data.total_price;

            buildItem.color_data.imprint_locations_price = this.calculateDecorationColorsPricing(buildItem.color_data.total_quantity, buildItem.color_data, buildItem);

            buildItem.color_data.total_price+= parseFloat(buildItem.color_data.front_number_fees)
                + parseFloat(buildItem.color_data.back_name_fees)
                + parseFloat(buildItem.color_data.back_number_fees || 0)
                + parseFloat(buildItem.color_data.front_number_decor_up_fees || 0)
                + parseFloat(buildItem.color_data.back_name_decor_up_fees || 0)
                + parseFloat(buildItem.color_data.back_number_decor_up_fees || 0)
                + parseFloat(buildItem.color_data.imprint_locations_price || 0);

            let non_standard_colors = buildItem.non_standard_colors
                ? JSON.parse(buildItem.non_standard_colors)
                : [];

            if (non_standard_colors) {
                buildItem.color_data.non_standard_fees = 0;
                buildItem.color_data.total_price+=parseFloat(buildItem.color_data.non_standard_fees);
            }
        },

        calculatePricing(buildItem, size, event = null) {
            var _this = this;
            if (!buildItem.MainNewProduct) {
                console.error('MainNewProduct is null for buildItem:', buildItem);
                return;
            }
            let product = buildItem.MainNewProduct;
            if (event && (event.target.value > _this.max_cart_count)) {
                let error_message = `${buildItem.Color ? buildItem.Color.name : 'Unknown'} (${product.product_number}) Quantity should not be greater than  ${this.max_cart_count}`;
                _this.$toast.error(error_message, {
                    position: "top-right",
                    queue: true
                });
                event.target.value = 0;
                size.quantity = null;
            } else {
                if (product.decoration_type == 1) {
                    _this.calculatePrintPricing(product);
                } else if (product.decoration_type == 2) {
                    _this.calculateEmbroideryPricing(product);
                }
            }
        },

        calculatePrintPricing() {

            this.build_details.total_price = 0;
            this.build_details.total_front_number_fees = 0;
            this.build_details.total_back_name_fees = 0;
            this.build_details.total_back_number_fees = 0;
            this.build_details.total_front_number_decor_up_fees = 0;
            this.build_details.total_back_name_decor_up_fees = 0;
            this.build_details.total_back_number_decor_up_fees = 0;
            this.build_details.total_colors_fee = 0;
            this.build_details.setup_fee = 0;
            this.build_details.OrderBuildItems.forEach((buildItem) => {
                this.calculateAllCharges(buildItem, this.build_details);
                this.build_details.total_price+=parseFloat(buildItem.color_data.total_price);
                this.build_details.setup_fee+=parseFloat(buildItem.color_data.setup_fee || 0);
                this.build_details.total_front_number_fees+=parseFloat(buildItem.color_data.front_number_fees || 0);
                this.build_details.total_back_name_fees+=parseFloat(buildItem.color_data.back_name_fees || 0);
                this.build_details.total_back_number_fees+=parseFloat(buildItem.color_data.back_number_fees || 0);
                this.build_details.total_front_number_decor_up_fees+=parseFloat(buildItem.color_data.front_number_decor_up_fees || 0);
                this.build_details.total_back_name_decor_up_fees+=parseFloat(buildItem.color_data.back_name_decor_up_fees || 0);
                this.build_details.total_back_number_decor_up_fees+=parseFloat(buildItem.color_data.back_number_decor_up_fees || 0);
                this.build_details.total_colors_fee+=parseFloat(buildItem.color_data.imprint_locations_price);
            });
            this.build_details.total_price+=this.build_details.total_non_standard_fees 
                + this.build_details.setup_fee;
        },

        calculateEmbroideryPricing() {
            this.build_details.total_price = 0;
            this.build_details.total_front_number_fees = 0;
            this.build_details.total_back_name_fees = 0;
            this.build_details.total_back_number_fees = 0;
            this.build_details.total_front_number_decor_up_fees = 0;
            this.build_details.total_back_name_decor_up_fees = 0;
            this.build_details.total_back_number_decor_up_fees = 0;
            this.build_details.total_colors_fee = 0;
            this.build_details.setup_fee = 0;
            this.build_details.OrderBuildItems.forEach((buildItem) => {
                this.calculateAllCharges(buildItem, this.build_details);
                this.build_details.setup_fee+=parseFloat(buildItem.color_data.setup_fee || 0);
                this.build_details.total_price+=parseFloat(buildItem.color_data.total_price);

                this.build_details.total_front_number_fees+=parseFloat(buildItem.color_data.front_number_fees || 0);
                this.build_details.total_back_name_fees+=parseFloat(buildItem.color_data.back_name_fees || 0);
                this.build_details.total_back_number_fees+=parseFloat(buildItem.color_data.back_number_fees || 0);
                this.build_details.total_front_number_decor_up_fees+=parseFloat(buildItem.color_data.front_number_decor_up_fees || 0);
                this.build_details.total_back_name_decor_up_fees+=parseFloat(buildItem.color_data.back_name_decor_up_fees || 0);
                this.build_details.total_back_number_decor_up_fees+=parseFloat(buildItem.color_data.back_number_decor_up_fees || 0);
                this.build_details.total_colors_fee+=parseFloat(buildItem.color_data.imprint_locations_price);
            });
            this.build_details.total_price+=this.build_details.total_non_standard_fees 
                + this.build_details.setup_fee;
        },

        getTotalBuildQuantity(build) {
            let total_quantity = 0;
            build.OrderBuildItems.forEach(item => {
                item.color_data.sizes.forEach(size => {
                    if (size.quantity > 0) {
                        total_quantity += parseInt(size.quantity);
                    }
                })
            })
            return total_quantity;
        },

        getTotalItemQuantity(buildItem) {
            let total_quantity = 0;
            buildItem.color_data.sizes.forEach(size => {
                if (size.quantity > 0) {
                    total_quantity += parseInt(size.quantity);
                }
            })
            return total_quantity;
        },

        getDecorationPrice(product, total_quantity, colorIndex = 0, locationIndex = undefined, additional = false) {
            let qty_wise_color_price = 0;

            if (product.decoration_type == 1) {
                let decoration_data;

                if (!additional) {
                    decoration_data = product.price_decoration_bulk.print_location1;
                } else {
                    decoration_data = product.price_decoration_bulk.print_location2;
                }

                for (const [index, element] of Object.entries(decoration_data)) {
                    if (element.quantity <= total_quantity || index == 0) {
                        qty_wise_color_price = element[`colour${colorIndex + 1}`];
                    }
                }
            } else if (product.decoration_type == 2) {
                let decoration_data = product.price_decoration_bulk;
                for (const [index, element] of Object.entries(decoration_data)) {
                    if (element.quantity1 <= total_quantity || index == 0) {
                        if (locationIndex > 0) {
                            qty_wise_color_price = element[`location${locationIndex+1}`];
                        } else {
                            qty_wise_color_price = element['cost'];
                        }
                    }
                }
            }

            return parseFloat(qty_wise_color_price || 0);
        },

        getDecorationDiscount(product, total_quantity, additional = false) {
            let discount = 0;
            if (product.decoration_type == 1) {
                let decoration_data;

                if (!additional) {
                    decoration_data = product.price_decoration_bulk.print_location1;
                } else {
                    decoration_data = product.price_decoration_bulk.print_location2;
                }

                for (const [index, element] of Object.entries(decoration_data)) {
                    if (element.quantity <= total_quantity || index == 0) {
                        discount = element['discount'];
                    }
                }
            } else if (product.decoration_type == 2) {
                let decoration_data = product.price_decoration_bulk;
                for (const [index, element] of Object.entries(decoration_data)) {
                    if (element.quantity1 <= total_quantity || index == 0) {
                        discount = element['discount'];
                    }
                }
            }

            return parseFloat(discount || 0);
        },

        getDecorationTemplateData(decorationType, decorationTemplateId) {
            let decorationTemplate;

            if (decorationType == 1) {
                decorationTemplate = this.printTemplates.find(temp => temp.id == decorationTemplateId);
            } else if (decorationType == 2) {
                decorationTemplate = this.embroideryTemplates.find(temp => temp.id == decorationTemplateId);
            }

            return decorationTemplate;
        },

        prepareLocations(imprint_locations, build_item) {
            let no_of_colors = 0;
            imprint_locations.forEach(location => {
                location.colors = [];
                if (build_item[`${location.location.toLowerCase()}_decoration_colors`]) {
                    let decorationColors = build_item[`${location.location.toLowerCase()}_decoration_colors`]
                    decorationColors.forEach(colorHex => {
                        let vendorColor = this.vendor_colors_list.find(vendColor => vendColor.color_value.toLowerCase() == colorHex.toLowerCase());
                        location.colors.push({
                            color: vendorColor || this.nonStandardColorObj,
                            total_decor_upcharge: 0
                        });
                    })
                    
                    location.no_of_color = decorationColors.length;
                }
                location.price = 0;
                location.total_decoration_fee = 0;
                location.total_price = 0;
                if (location.no_of_color) {
                    no_of_colors+=parseInt(location.no_of_color || 0);
                }
            });

            return { imprint_locations, no_of_colors };
        },

        calculateDecorationColorsPricing(total_quantity, buildData, product) {
            let imprint_locations_price = 0;
            let initalLocationIndex = 0;
            if (product.decoration_type == 1) {
                buildData.imprint_locations.forEach((location) => {
                    if (location.is_selected) {
                        let no_of_colors = parseInt(location.no_of_color) || 0;
                        if ((initalLocationIndex == 0) && (no_of_colors == 1)) {
                            location.decoration_fee = 0;
                            location.total_decoration_fee = 0;
                        } else {
                            let decoration_price = this.getDecorationPrice(product, total_quantity, no_of_colors - 1, undefined, initalLocationIndex > 0);
                            let color1_decoration_price = this.getDecorationPrice(product, total_quantity,0, undefined, initalLocationIndex > 0);
                            location.decoration_fee = parseFloat(decoration_price);
                            if ((initalLocationIndex == 0) && (location.decoration_fee > 0)) {
                                location.decoration_fee = parseFloat(location.decoration_fee) - parseFloat(color1_decoration_price)
                            }
                            location.total_decoration_fee = parseFloat(location.decoration_fee) * total_quantity;
                        }
                        /* eslint-disable */
                        let total_location_fee = location.total_decoration_fee;
                        location.colors.forEach(color => {
                            if (color.color){
                                color.total_decor_upcharge =  parseFloat(color.color.decor_upcharge || 0) * total_quantity;
                                total_location_fee+=parseFloat(color.total_decor_upcharge);
                                imprint_locations_price+=parseFloat(color.total_decor_upcharge);
                            }
                        });
                        /* eslint-enable */
                        imprint_locations_price+=location.total_decoration_fee;

                        initalLocationIndex++;
                    }
                })
            } else if (product.decoration_type == 2) {
                buildData.imprint_locations.forEach((location) => {
                    if (location.is_selected) {
                        let no_of_colors = parseInt(location.no_of_color) || 0;
                        if (initalLocationIndex == 0) {
                            location.decoration_fee = 0;
                            location.total_decoration_fee = 0;
                        } else {
                            let decoration_price = 0;
                            if (no_of_colors > 0) {
                                decoration_price = this.getDecorationPrice(product, total_quantity, 0, initalLocationIndex);
                            }
                            location.decoration_fee = parseFloat(decoration_price);
                            location.total_decoration_fee = parseFloat(location.decoration_fee) * total_quantity
                        }
                        /* eslint-disable */
                        let total_location_fee = location.total_decoration_fee;
                        location.colors.forEach(color => {
                            if (color.color) {
                                color.total_decor_upcharge =  parseFloat(color.color.decor_upcharge || 0) * total_quantity;
                                total_location_fee+=parseFloat(color.total_decor_upcharge);
                                imprint_locations_price+=parseFloat(color.total_decor_upcharge);
                            }
                        });
                        /* eslint-enable */
                        imprint_locations_price+=location.total_decoration_fee;

                        initalLocationIndex++;
                    }
                })
            }

            return imprint_locations_price;
        },

        prepareDecorationPrices(product) {
            if (!product) {
                console.error('Product is null in prepareDecorationPrices');
                return;
            }
            if (product.decoration_type == 1) {
                product.decoration_price_template_values_for_imprint = product.price_decoration_bulk.print_location1;
                product.decoration_price_template_values = product.price_decoration_bulk.print_location1;
                product.decoration_price_template_location2 = product.price_decoration_bulk.print_location2;
            } else if (product.decoration_type == 2) {
                product.decoration_price_template_values_for_imprint = product.price_decoration_bulk;
                product.decoration_price_template_values = product.price_decoration_bulk;
            }
        },

        existsNameAndNumber(data, type) {
            let is_exist = data.find((nn) => nn[type] != "");
            return is_exist;
        },

        getRetailPrice(prices) {
            let item_price = 0;
            if (prices.base_price) {
                item_price+=parseFloat(prices.base_price);
            }

            if (prices.markup_price) {
                item_price+=parseFloat(prices.markup_price);
            }

            if (prices.single_location_price) {
                item_price+=parseFloat(prices.single_location_price);
            }

            if (prices.color_category_price) {
                item_price+=parseFloat(prices.color_category_price);
            }

            if (prices.decoration_discount_percentage) {
                let decoration_discount_value = this.icPriceFormat(item_price, true) * parseFloat(prices.decoration_discount_percentage) / 100;
                item_price-=parseFloat(decoration_discount_value);
            }

            return item_price;
        },

        getDarkLightFees(color, product) {
            if (!product) {
                return 0;
            }
            if (color) {
                if (color.category == 'Dark') {
                    return parseFloat(product.price_color_category_dark || 0);
                } else if (color.category == 'Light') {
                    return parseFloat(product.price_color_category_light || 0);
                }
            }

            return 0;
        },

        getAllMarkupTiers() {
            return new Promise((resolve, reject) => {
                ApiService.get("/get-markup-tiers").then(({ data }) => {
                    if (data.error) {
                        this.$toast.error(data.error, { position: 'top-right', queue: true });
                        return;
                    }
                    this.markup_tiers = data.markup_tiers;
                    resolve(data);
                }).catch((response) => {
                    reject(response);
                });
            });
        },

        getMarkupFromTier(price, decoration_type, decoration_price_template) {
            let markup = 0;
            let tier = this.markup_tiers.find((tier) => 
                (decoration_type == tier.decoration_id) &&
                (decoration_price_template == tier.template_id) &&
                (parseFloat(tier.start_price) <= parseFloat(price)) && 
                (parseFloat(tier.end_price) >= parseFloat(price))
            );
            if (tier) {
                markup = tier.markup;
            }
            return markup;
        },

        prepareCartItems() {
            let cart_items = [];

            this.build_details.OrderBuildItems.forEach((buildItem) => {
                let design_images = [];
                let item_design_areas_inches = JSON.parse(buildItem.design_area_inches);
                if (buildItem.front_image && item_design_areas_inches.find(area => area.label == 'Front').label == 'Front') {
                    let current_item_design_areas_inches = item_design_areas_inches.find(area => area.label == 'Front');
                    let frontImg = { label: (typeof current_item_design_areas_inches.label_show !== undefined) ? current_item_design_areas_inches.label_show : current_item_design_areas_inches.label, url: buildItem.front_image, canvas_images: [] };
                    if (this.build_details.front_image) {
                        frontImg.design_image = this.build_details.front_image;
                        const frontDesign = this.build_details.front_design 
                            ? JSON.parse(this.build_details.front_design): 
                            null
                        if (frontDesign && frontDesign.objects) {
                            frontDesign.objects.forEach((canvas_obj) => {
                                if (canvas_obj.image_name) {
                                    frontImg.canvas_images.push({
                                        image_name: canvas_obj.image_name,
                                        image_path: canvas_obj.image_path,
                                        height_inch: canvas_obj.height_inch,
                                        width_inch: canvas_obj.width_inch
                                    });
                                }
                            });
                        }
                    }
                    design_images.push(frontImg);
                }
                if (buildItem.back_image && item_design_areas_inches.find(area => area.label == 'Back').label == 'Back') {
                    let current_item_design_areas_inches = item_design_areas_inches.find(area => area.label == 'Back');
                    let backImg = { label: (typeof current_item_design_areas_inches.label_show !== undefined) ? current_item_design_areas_inches.label_show : current_item_design_areas_inches.label, url: buildItem.back_image, canvas_images: [] };
                    if (this.build_details.back_image) {
                        backImg.design_image = this.build_details.back_image;
                        const backDesign = this.build_details.back_design 
                            ? JSON.parse(this.build_details.back_design): 
                            null
                        if (backDesign && backDesign.objects) {
                            backDesign.objects.forEach((canvas_obj) => {
                                if (canvas_obj.image_name) {
                                    backImg.canvas_images.push({
                                        image_name: canvas_obj.image_name,
                                        image_path: canvas_obj.image_path,
                                        height_inch: canvas_obj.height_inch,
                                        width_inch: canvas_obj.width_inch
                                    });
                                }
                            });
                        }
                    }
                    design_images.push(backImg);
                }
                if (buildItem.left_image && item_design_areas_inches.find(area => area.label == 'Left').label == 'Left') {
                    let current_item_design_areas_inches = item_design_areas_inches.find(area => area.label == 'Left');
                    let leftImg = { label: (typeof current_item_design_areas_inches.label_show !== undefined) ? current_item_design_areas_inches.label_show : current_item_design_areas_inches.label,  url: buildItem.left_image, canvas_images: [] };
                    if (this.build_details.left_image) {
                        leftImg.design_image = this.build_details.left_image;
                        const leftDesign = this.build_details.left_design 
                            ? JSON.parse(this.build_details.left_design): 
                            null
                        if (leftDesign && leftDesign.objects) {
                            leftDesign.objects.forEach((canvas_obj) => {
                                if (canvas_obj.image_name) {
                                    leftImg.canvas_images.push({
                                        image_name: canvas_obj.image_name,
                                        image_path: canvas_obj.image_path,
                                        height_inch: canvas_obj.height_inch,
                                        width_inch: canvas_obj.width_inch
                                    });
                                }
                            });
                        }
                    }
                    design_images.push(leftImg);
                }
                if (buildItem.right_image && item_design_areas_inches.find(area => area.label == 'Right').label == 'Right') {
                    let current_item_design_areas_inches = item_design_areas_inches.find(area => area.label == 'Right');
                    let rightImg = { label: (typeof current_item_design_areas_inches.label_show !== undefined) ? current_item_design_areas_inches.label_show : current_item_design_areas_inches.label,  url: buildItem.right_image, canvas_images: [] };
                    if (this.build_details.right_image) {
                        rightImg.design_image = this.build_details.right_image;
                        const rightDesign = this.build_details.right_design 
                            ? JSON.parse(this.build_details.right_design): 
                            null
                        if (rightDesign && rightDesign.objects) {
                            rightDesign.objects.forEach((canvas_obj) => {
                                if (canvas_obj.image_name) {
                                    rightImg.canvas_images.push({
                                        image_name: canvas_obj.image_name,
                                        image_path: canvas_obj.image_path,
                                        height_inch: canvas_obj.height_inch,
                                        width_inch: canvas_obj.width_inch
                                    });
                                }
                            });
                        }
                    }
                    design_images.push(rightImg);
                }

                let subItems = [];

                let sub_total_price= 0;
                buildItem.color_data.sizes.forEach(size => {
                    // if (size.quantity > 0) {
                        subItems.push({
                            sub_product_id: size.sub_product_id,
                            user_id: this.build_details.created_by,
                            case_price: size.case_price,
                            markup_price: parseFloat(size.markup_price).toFixed(2),
                            markup_percentage: size.markup_percentage || 0,
                            ink_price: size.ink_price||0,
                            single_location_price: size.single_location_price||0,
                            quantity: size.quantity||0,
                            discount: size.discount || 0.00,
                            unit_price: size.unit_price || 0,
                            total_price: size.total_price || 0,
                        })
                        if (size.total_price) {
                            sub_total_price+=parseFloat(size.total_price);
                        }
                    // }
                })

                cart_items.push({
                    user_id: this.build_details.created_by,
                    item_id: buildItem.product_id,
                    gender_size_id: buildItem.gender_size_id,
                    color_id: buildItem.color_id,
                    build_id: this.build_details.id,
                    decoration_type: buildItem.MainNewProduct.decoration_type,
                    decoration_price_template: buildItem.MainNewProduct.decoration_price_template,
                    price_decoration_bulk: buildItem.MainNewProduct.price_decoration_bulk,
                    more_decorations: buildItem.MainNewProduct.more_decoration,
                    items: subItems,
                    imprint_locations: buildItem.color_data.imprint_locations || [],
                    total_design_fee: buildItem.color_data.total_design_fee,
                    total_dark_category_fee: buildItem.color_data.total_dark_category_fee,
                    total_light_category_fee: buildItem.color_data.total_light_category_fee,
                    total_quantity: buildItem.color_data.total_quantity,
                    total_price: buildItem.color_data.total_price,
                    setup_fee: buildItem.color_data.setup_fee,
                    imprint_locations_price: buildItem.color_data.imprint_locations_price,
                    subtotal_price: sub_total_price,
                    design_image: design_images,
                    design_area_inches : buildItem.design_area_inches,
                    t_shirt_24_hour: buildItem.t_shirt_24_hour,
                    item_prices: {
                        front_number_fees: buildItem.color_data.front_number_fees,
                        back_name_fees: buildItem.color_data.back_name_fees,
                        back_number_fees: buildItem.color_data.back_number_fees,
                        front_number_decor_up_fees: buildItem.color_data.front_number_decor_up_fees,
                        back_name_decor_up_fees: buildItem.color_data.back_name_decor_up_fees,
                        back_number_decor_up_fees: buildItem.color_data.back_number_decor_up_fees,
                        selected_name_number: buildItem.color_data.selected_name_number
                    },
                    non_standard_colors: buildItem.non_standard_colors ? JSON.parse(buildItem.non_standard_colors) : [],
                    decoration_colors: buildItem.decoration_colors ? JSON.parse(buildItem.decoration_colors) : [],
                    location_decoration_colors: { 
                        front: buildItem.front_decoration_colors || [],
                        back: buildItem.back_decoration_colors || [],
                        left: buildItem.left_decoration_colors || [],
                        right: buildItem.right_decoration_colors || [],
                    },
                    name_and_number_json: buildItem.name_and_number_json ? buildItem.name_and_number_json : [],
                    font_color_sizes_name: buildItem.font_color_sizes_name ? JSON.parse(buildItem.font_color_sizes_name) : [],
                    font_color_sizes_number: buildItem.font_color_sizes_number ? JSON.parse(buildItem.font_color_sizes_number) : [],
                });
            });

            return cart_items;
        },

        validPrices() {
            let total_build_quantity = 0;
            this.build_details.OrderBuildItems.forEach(item => {
                total_build_quantity+=parseInt(item.color_data.total_quantity);
            })
            let min_quantity_error = false;
            let max_quantity_error = false;
            let no_quantity_error = false
            let miniumQuantity = 0;
            this.build_details.OrderBuildItems.forEach(item => {
                if (item.MainNewProduct.decoration_type == 1){
                    miniumQuantity = item.MainNewProduct.decoration_price_template_values[0].quantity;
                } else if (item.MainNewProduct.decoration_type == 2) {
                    miniumQuantity = item.MainNewProduct.decoration_price_template_values[0].quantity1;
                } else if (item.MainNewProduct.decoration_type == 3) {
                    miniumQuantity = item.MainNewProduct.decoration_price_template_values[0].quantity;
                }

                if (item.color_data.total_quantity== 0) {
                    no_quantity_error = true;
                    return;
                } else if (total_build_quantity < miniumQuantity) {
                    min_quantity_error = true
                    return;
                } 

                const sizeQuantity = item.color_data.sizes.find(size => size.quantity > this.max_cart_count);
                if (sizeQuantity) {
                    max_quantity_error = true;
                    return;
                }
            })

            if (no_quantity_error) {
                this.$toast.error('Every Item should have atleast one single quantity is required', { position: 'top-right', queue: true });
                return false;
            }

            if (min_quantity_error) {
                this.$toast.error(`Quantity should be greater than ${miniumQuantity}`, { position: 'top-right', queue: true });
                return false;
            }

            if (max_quantity_error) {
                this.$toast.error(`Quantity should not be greater than ${this.max_cart_count}`, { position: 'top-right', queue: true });
                return false;
            }

            return true;
        },

        saveForLater() {

            if (!this.validPrices()) {
                return;
            }

            return new Promise((resolve, reject) => {
                let params = {
                    build_id: this.build_details.id,
                    build_items: this.build_details.OrderBuildItems.map(item => ({ id: item.id, color_data: item.color_data }))
                }
                this.isLoader = true;
                ApiService.post('/build-items-update', params).then(({ data }) => {
                    this.isLoader = false;
                    if (!data.success) {
                        this.$toast.error(data.error, { position: 'top-right', queue: true });
                        return;
                    }
                    this.$toast.success(
                        "Build items data saved for later",
                        { position: "top-right", queue: true }
                    );
                    this.$router.push({ name: 'BuildListV3' });
                    resolve(data)
                }).catch((err) => {
                    console.log(err);
                    this.isLoader = false;
                    reject(err);
                })
            })
        },

        addToCart() {
            if (!this.validPrices()) {
                return;
            }
            
            this.isLoader = true;
            return new Promise((resolve, reject) => {
                const cartItems = this.prepareCartItems();
                ApiService.post("/add-to-cart", cartItems).then(({ data }) => {
                    this.isLoader = false;
                    if (!data.success) {
                        this.$toast.error(data.error, { position: 'top-right', queue: true });
                        return;
                    }
                    this.$toast.success("Product has been added into the cart successfully.",
                        { position: "top-right", queue: true }
                    );
                    this.$root.$emit("update-cart", { type: "success" });
                    this.$router.push({ name: 'cartV3' });
                    
                    resolve(data);
                }).catch((err) => {
                    console.log(err);
                    this.isLoader = false;
                    reject(err);
                })
            });
        },

        getVendorData(vendor_id, colors_type) {
            return new Promise((resolve, reject) => {
                ApiService.get(`/vendors/${vendor_id}`).then(({ data }) => {
                    if (data.error) {
                        this.$toast.error(data.error, { position: 'top-right', queue: true });
                        return;
                    }
                    this.vendor_data = data.vendor;
                    let colors_json = this.vendor_data.vendor_colors ? JSON.parse(this.vendor_data.vendor_colors) : {};
                    this.vendor_colors_list = colors_json[`color_data_for_${colors_type}`];
                    resolve(data.colors);
                })
                .catch((err) => {
                    reject(err);
                })
            })
        },

        openNameNumbersModal(buildItem) {
            this.name_and_number_json = { front: [], back: [] };
            this.selected_name_number = buildItem.color_data.selected_name_number;
            if (buildItem.color_data.selected_name_number) {
                if (buildItem.color_data.selected_name_number.front.number) {
                    this.name_and_number_json['front'] = buildItem.name_and_number_json.filter(nn => nn.number);
                }
                if (buildItem.color_data.selected_name_number.back.name || buildItem.color_data.selected_name_number.back.number) {
                    this.name_and_number_json['back'] = buildItem.name_and_number_json.filter(nn => (nn.name!="") || (nn.number))
                }
            }
            /* eslint-disable */
            $('#nameNumbersModal').modal('show');
            /* eslint-enable */
        },
    },
}
</script>